// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-04T16:50:51.011Z
// Company: Case & Associates
// Properties: 94 (summaries only — full data in /data/properties/*.json)

export const company = {
  "company_id": "5767906449162419",
  "company_name": "Case & Associates",
  "company_url": "https://www.caseusa.com/",
  "logo_url": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
  "icon_url": null,
  "primary_color": null,
  "primary_font": null,
  "tagline": null,
  "about": null,
  "overview": null,
  "headquarters_location": null,
  "facebook_url": null,
  "twitter_url": null,
  "instagram_url": null,
  "linkedin_url": null
};

export const propertySummaries = [
  {
    "multihub_property_id": "6767906449165580",
    "multihub_company_id": "5767906449162419",
    "property_name": "24Hundred Apartments",
    "property_slug": "24hundred-apartments",
    "property_address": "2400 Watermark Blvd",
    "property_address_1": "2400 Watermark Blvd",
    "property_address_city": "Oklahoma City",
    "property_address_state": "OK",
    "property_address_zip": "73134",
    "property_address_latitude": "35.6192",
    "property_address_longitude": "-97.5581",
    "property_phone": "(405) 242-1629",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019dbbe7-650c-7454-baf1-5f0c0272012a.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019cfb37-7611-7353-944d-f9247ebeb6f8.webp",
    "property_primary_color": "#324d58",
    "property_price_range": "1189 - 1699",
    "property_price_min": "1189",
    "property_price_max": "1699",
    "property_bedrooms_range": "1 - 2",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "2",
    "property_bathrooms_range": "1 - 2.5",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2.5",
    "property_sqft_range": "789 - 1246",
    "property_short_description": "Welcome to 24Hundred Apartments, where modern living meets endless amenities! Choose from spacious one, two, or three-bedroom designs, each featuring high ceilings, stainless appliances, and walk-in closets. Enjoy a resort-style pool, fitness center, and a dog park—all in a gated community close to shops and entertainment. Your new home awaits! Prefer to explore on your own time? Self-guided tours are available.",
    "property_type": "Apartments",
    "property_total_units": "299",
    "property_website_url": "https://www.caseusa.com/apartments/ok/oklahoma-city/24hundred-apartments/",
    "property_company_name": "Case & Associates",
    "_slug": "24hundred-apartments",
    "_stateSlug": "ok",
    "_citySlug": "oklahoma-city"
  },
  {
    "multihub_property_id": "6767906449165581",
    "multihub_company_id": "5767906449162419",
    "property_name": "97 @ North Oak",
    "property_slug": "97-@-north-oak",
    "property_address": "97 NE 97th St.",
    "property_address_1": "97 NE 97th St.",
    "property_address_city": "Kansas City",
    "property_address_state": "MO",
    "property_address_zip": "64155",
    "property_address_latitude": "39.2701",
    "property_address_longitude": "-94.5774",
    "property_phone": "(816) 281-9866",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019dbbe7-648c-774a-a48f-f734385e4e24.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019cfb38-cbf6-730b-aee2-3e765f6b8f96.webp",
    "property_primary_color": "#00adbb",
    "property_price_range": "1289 - 2065",
    "property_price_min": "1289",
    "property_price_max": "2065",
    "property_bedrooms_range": "1 - 3",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "3",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "789 - 1409",
    "property_short_description": "Nestled in the heart of Kansas City, 97 at North Oak offers a vibrant blend of style and comfort. Choose from spacious one, two, or three-bedroom apartments, each featuring modern amenities like stainless steel appliances and walk-in closets. Enjoy our inviting pool, fitness center, and pet-friendly spaces. Your ideal lifestyle awaits! Prefer to explore on your own time? Self-guided tours are available.",
    "property_type": "Apartments",
    "property_total_units": "317",
    "property_website_url": "https://www.caseusa.com/apartments/mo/kansas-city/97-north-oak/",
    "property_company_name": "Case & Associates",
    "_slug": "97-north-oak",
    "_stateSlug": "mo",
    "_citySlug": "kansas-city"
  },
  {
    "multihub_property_id": "6767906449165582",
    "multihub_company_id": "5767906449162419",
    "property_name": "Acacia Park Apts.",
    "property_slug": "acacia-park-apts.",
    "property_address": "5848 Acacia Circle",
    "property_address_1": "5848 Acacia Circle",
    "property_address_city": "El Paso",
    "property_address_state": "TX",
    "property_address_zip": "79912",
    "property_address_latitude": "31.8268",
    "property_address_longitude": "-106.5197",
    "property_phone": "(915) 233-2394",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019fb44b-23c3-7021-ad82-d83247f56d18.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019cfb37-65ac-7129-a45b-261982edc03b.webp",
    "property_primary_color": "#58595b",
    "property_price_range": "1294 - 1680",
    "property_price_min": "1294",
    "property_price_max": "1680",
    "property_bedrooms_range": "1 - 3",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "3",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "642 - 1075",
    "property_short_description": "Welcome to Acacia Park Apts., where comfort meets convenience in beautiful El Paso, Texas. Choose from our spacious one, two, and three-bedroom floor plans, complemented by top-notch amenities like a shimmering pool, fitness center, and dog park. Your ideal home awaits—schedule a tour or browse our availability today! Prefer to explore on your own time? Self-guided tours are available.",
    "property_type": "Apartments",
    "property_total_units": "336",
    "property_website_url": "https://www.caseusa.com/apartments/tx/el-paso/acacia-park/",
    "property_company_name": "Case & Associates",
    "_slug": "acacia-park-apts",
    "_stateSlug": "tx",
    "_citySlug": "el-paso"
  },
  {
    "multihub_property_id": "6767906449165583",
    "multihub_company_id": "5767906449162419",
    "property_name": "Apple Creek Stillwater",
    "property_slug": "apple-creek-stillwater",
    "property_address": "1200 N Perkins Road",
    "property_address_1": "1200 N Perkins Road",
    "property_address_city": "Stillwater",
    "property_address_state": "OK",
    "property_address_zip": "74075",
    "property_address_latitude": "36.1352",
    "property_address_longitude": "-97.0521",
    "property_phone": "(405) 266-5233",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165583/019fb44b-28d2-740d-bc7d-99bffc1ce1f0.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165583/019cfb37-55bc-75b2-93e2-0eaf5a0f3aa4.webp",
    "property_primary_color": "#65a243",
    "property_price_range": "804 - 1104",
    "property_price_min": "804",
    "property_price_max": "1104",
    "property_bedrooms_range": "1 - 2",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "2",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "424 - 978",
    "property_short_description": "Welcome to Apple Creek Stillwater, where modern living meets comfort in the heart of Stillwater, Oklahoma. Choose from stylish studio, one, or two-bedroom floor plans featuring hardwood floors and granite countertops. Enjoy top-notch amenities including a refreshing pool, vibrant clubhouse, and tranquil courtyard. Find your new home today!",
    "property_type": "Apartments",
    "property_total_units": "351",
    "property_website_url": "https://www.caseusa.com/apartments/ok/stillwater/apple-creek/",
    "property_company_name": "Case & Associates",
    "_slug": "apple-creek-stillwater",
    "_stateSlug": "ok",
    "_citySlug": "stillwater"
  },
  {
    "multihub_property_id": "6767906449165584",
    "multihub_company_id": "5767906449162419",
    "property_name": "Arbors of Pleasant Valley Apts",
    "property_slug": "arbors-of-pleasant-valley-apts",
    "property_address": "2020 Hinson Loop",
    "property_address_1": "2020 Hinson Loop",
    "property_address_city": "Little Rock",
    "property_address_state": "AR",
    "property_address_zip": "72212",
    "property_address_latitude": "34.7725",
    "property_address_longitude": "-92.4061",
    "property_phone": "(501) 727-2115",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165584/019fb44b-149d-73ae-9168-bf6317201c11.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165584/019cfb37-5a41-7739-80b2-20742c0d88df.webp",
    "property_primary_color": "#715840",
    "property_price_range": "864 - 1084",
    "property_price_min": "864",
    "property_price_max": "1084",
    "property_bedrooms_range": "1 - 3",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "3",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "636 - 1058",
    "property_short_description": "Welcome to Arbors of Pleasant Valley Apts in Little Rock, where comfort meets style! Choose from spacious one, two, or three-bedroom floor plans, featuring high ceilings and energy-efficient appliances. Enjoy a pet-friendly environment with a fitness center, outdoor pool, and cozy coffee bar. Ready to elevate your lifestyle? Schedule a tour today!",
    "property_type": "Apartments",
    "property_total_units": "184",
    "property_website_url": "https://www.caseusa.com/apartments/ar/little-rock/arbors-of-pleasant-valley/",
    "property_company_name": "Case & Associates",
    "_slug": "arbors-of-pleasant-valley-apts",
    "_stateSlug": "ar",
    "_citySlug": "little-rock"
  },
  {
    "multihub_property_id": "6767906449165585",
    "multihub_company_id": "5767906449162419",
    "property_name": "Artisan Crossing Apts",
    "property_slug": "artisan-crossing-apts",
    "property_address": "1303 West Tecumseh Road",
    "property_address_1": "1303 West Tecumseh Road",
    "property_address_city": "Norman",
    "property_address_state": "OK",
    "property_address_zip": "73069",
    "property_address_latitude": "35.2625",
    "property_address_longitude": "-97.4629",
    "property_phone": "(405) 450-7918",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019cfb38-90db-717d-9484-83d9a4b44b05.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019cfb39-1f7f-700c-a827-b3538007b51a.webp",
    "property_primary_color": "#324d58",
    "property_price_range": "1569 - 1979",
    "property_price_min": "1569",
    "property_price_max": "1979",
    "property_bedrooms_range": "2 - 2",
    "property_bedrooms_min": "2",
    "property_bedrooms_max": "2",
    "property_bathrooms_range": "2 - 2.5",
    "property_bathrooms_min": "2",
    "property_bathrooms_max": "2.5",
    "property_sqft_range": "1050 - 1350",
    "property_short_description": "At Artisan Crossing Apts in Norman, Oklahoma, your dream home awaits! Choose from stylish one and two-bedroom floor plans featuring modern amenities like a resort-style pool, 24-hour fitness center, and dog park. Experience the allure of expansive living spaces and unmatched convenience—your new lifestyle starts here! Prefer to explore on your own time? Self-guided tours are available.",
    "property_type": "Apartments",
    "property_total_units": "246",
    "property_website_url": "https://www.caseusa.com/apartments/ok/norman/artisan-crossing-apts/",
    "property_company_name": "Case & Associates",
    "_slug": "artisan-crossing-apts",
    "_stateSlug": "ok",
    "_citySlug": "norman"
  },
  {
    "multihub_property_id": "6767906449165586",
    "multihub_company_id": "5767906449162419",
    "property_name": "Barrington Apartments",
    "property_slug": "barrington-apartments",
    "property_address": "9233 E. 65th St.",
    "property_address_1": "9233 E. 65th St.",
    "property_address_city": "Tulsa",
    "property_address_state": "OK",
    "property_address_zip": "74133",
    "property_address_latitude": "36.0704",
    "property_address_longitude": "-95.8727",
    "property_phone": "(539) 207-4532",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019fb44b-2eea-755a-8708-09e27800bad5.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb39-2914-7206-ac11-405b0dad83bb.webp",
    "property_primary_color": "#b47f00",
    "property_price_range": "959 - 1499",
    "property_price_min": "959",
    "property_price_max": "1499",
    "property_bedrooms_range": "1 - 2",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "2",
    "property_bathrooms_range": "1 - 2.5",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2.5",
    "property_sqft_range": "600 - 1212",
    "property_short_description": "At Barrington Apartments in Tulsa, find your perfect home among our spacious one, two, and three-bedroom floor plans. Enjoy top-notch amenities like a refreshing pool, fitness center, and a vibrant clubhouse. With smoke-free living and high-speed internet, your ideal lifestyle awaits. Browse our availability or schedule a tour today! Prefer to explore on your own time? Self-guided tours are available.",
    "property_type": "Apartments",
    "property_total_units": "212",
    "property_website_url": "https://www.caseusa.com/apartments/ok/tulsa/barrington/",
    "property_company_name": "Case & Associates",
    "_slug": "barrington-apartments",
    "_stateSlug": "ok",
    "_citySlug": "tulsa"
  },
  {
    "multihub_property_id": "6767906449165587",
    "multihub_company_id": "5767906449162419",
    "property_name": "Cascata Luxury Apartments",
    "property_slug": "cascata-luxury-apartments",
    "property_address": "8001 S. Mingo Rd.",
    "property_address_1": "8001 S. Mingo Rd.",
    "property_address_city": "Tulsa",
    "property_address_state": "OK",
    "property_address_zip": "74133",
    "property_address_latitude": "36.0495",
    "property_address_longitude": "-95.866",
    "property_phone": "(539) 207-1644",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019fb44b-45e1-7608-b21d-88df672719da.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019cfb39-5f2b-7059-8d8d-91f620568c5c.webp",
    "property_primary_color": "#54504a",
    "property_price_range": "1164 - 1574",
    "property_price_min": "1164",
    "property_price_max": "1574",
    "property_bedrooms_range": "1 - 2",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "2",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "789 - 1176",
    "property_short_description": "Experience the vibrant lifestyle at Cascata Luxury Apartments in Tulsa, where spacious one- and two-bedroom homes meet exceptional amenities. Relax by the pool, work out in our fitness center, or stroll through scenic walking and biking trails. Your perfect oasis awaits—check our availability to uncover your ideal living space! Prefer to explore on your own time? Self-guided tours are available.",
    "property_type": "Apartments",
    "property_total_units": "431",
    "property_website_url": "https://www.caseusa.com/apartments/ok/tulsa/cascata/",
    "property_company_name": "Case & Associates",
    "_slug": "cascata-luxury-apartments",
    "_stateSlug": "ok",
    "_citySlug": "tulsa"
  },
  {
    "multihub_property_id": "6767906449165588",
    "multihub_company_id": "5767906449162419",
    "property_name": "Cedar Glade Apts",
    "property_slug": "cedar-glade-apts",
    "property_address": "9713 East 75th St.",
    "property_address_1": "9713 East 75th St.",
    "property_address_city": "Tulsa",
    "property_address_state": "OK",
    "property_address_zip": "74133",
    "property_address_latitude": "36.0571",
    "property_address_longitude": "-95.86726",
    "property_phone": "(539) 379-4400",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019cfb3a-549f-70fe-a904-92d8df77f0dd.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019cfb39-4343-72dc-aba1-260758975725.webp",
    "property_primary_color": "#64695c",
    "property_price_range": "919 - 1189",
    "property_price_min": "919",
    "property_price_max": "1189",
    "property_bedrooms_range": "1 - 2",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "2",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "725 - 1050",
    "property_short_description": "Welcome to Cedar Glade Apartments in Tulsa, where comfort meets convenience. Choose from spacious one, two, or three-bedroom floor plans, and enjoy exceptional amenities like a refreshing pool, a state-of-the-art fitness center, and a dog park. Your ideal sanctuary awaits—browse our availability and schedule a tour today! Prefer to explore on your own time? Self-guided tours are available.",
    "property_type": "Apartments",
    "property_total_units": "276",
    "property_website_url": "https://www.caseusa.com/apartments/ok/tulsa/cedar-glade/",
    "property_company_name": "Case & Associates",
    "_slug": "cedar-glade-apts",
    "_stateSlug": "ok",
    "_citySlug": "tulsa"
  },
  {
    "multihub_property_id": "6767906449165589",
    "multihub_company_id": "5767906449162419",
    "property_name": "Cedar Ridge Apartments",
    "property_slug": "cedar-ridge-apartments",
    "property_address": "11100 E. 96th St. S.",
    "property_address_1": "11100 E. 96th St. S.",
    "property_address_city": "Tulsa",
    "property_address_state": "OK",
    "property_address_zip": "74133",
    "property_address_latitude": "36.0240981",
    "property_address_longitude": "-95.8538529",
    "property_phone": "(539) 666-1483",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3a-22a5-7338-b12c-2cd51ef834d3.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3a-8a94-773d-b77e-156844fbd052.webp",
    "property_primary_color": "#463567",
    "property_price_range": "1199 - 1604",
    "property_price_min": "1199",
    "property_price_max": "1604",
    "property_bedrooms_range": "1 - 2",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "2",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "789 - 1108",
    "property_short_description": "<p>At Cedar Ridge Apartments in Tulsa, you’ll find thoughtfully designed one, two, and three-bedroom homes that combine comfort and style. Enjoy resort-style amenities, from a refreshing pool and state-of-the-art fitness center to tranquil outdoor spaces. Elevate your living experience—check availability and schedule your tour today! Prefer to explore on your own time? Self-guided tours are available.</p>",
    "property_type": "Apartments",
    "property_total_units": "337",
    "property_website_url": "https://www.caseusa.com/apartments/ok/tulsa/cedar-ridge/",
    "property_company_name": "Case & Associates",
    "_slug": "cedar-ridge-apartments",
    "_stateSlug": "ok",
    "_citySlug": "tulsa"
  },
  {
    "multihub_property_id": "6767906449165590",
    "multihub_company_id": "5767906449162419",
    "property_name": "Center 301",
    "property_slug": "center-301",
    "property_address": "301 Towne Center Drive",
    "property_address_1": "301 Towne Center Drive",
    "property_address_city": "Belton",
    "property_address_state": "Missouri",
    "property_address_zip": "64012",
    "property_address_latitude": "38.81815",
    "property_address_longitude": "-94.51633",
    "property_phone": "(833) 685-6030",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019fb44b-351f-745b-9623-0aff53fd603b.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019cfb3a-c898-729e-a8a0-c29afa67298d.webp",
    "property_primary_color": "#ffb548",
    "property_price_range": "1249 - 1709",
    "property_price_min": "1249",
    "property_price_max": "1709",
    "property_bedrooms_range": "1 - 2",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "2",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "789 - 1267",
    "property_short_description": "Welcome to Center 301 in Belton, Missouri, where luxurious living meets vibrant community life. Choose from spacious one and two-bedroom floor plans, each featuring modern amenities like stainless steel appliances, walk-in closets, and private patios. Unwind by the pool, work out in our fitness center, or enjoy a picnic near the scenic trails. Your perfect home awaits! Prefer to explore on your own time? Self-guided tours are available.",
    "property_type": "Apartments",
    "property_total_units": "306",
    "property_website_url": "https://www.caseusa.com/apartments/mo/belton/center-301/",
    "property_company_name": "Case & Associates",
    "_slug": "center-301",
    "_stateSlug": "mo",
    "_citySlug": "belton"
  },
  {
    "multihub_property_id": "6767906449165591",
    "multihub_company_id": "5767906449162419",
    "property_name": "Chardonnay",
    "property_slug": "chardonnay",
    "property_address": "7209 South 92nd East Avenue",
    "property_address_1": "7209 South 92nd East Avenue",
    "property_address_city": "Tulsa",
    "property_address_state": "OK",
    "property_address_zip": "74133",
    "property_address_latitude": "36.0588",
    "property_address_longitude": "-95.873",
    "property_phone": "(539) 379-5223",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019fb44b-40b1-72bf-9645-8de43564854c.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019cfb3a-d947-771e-a64a-f4cc9e06d28e.webp",
    "property_primary_color": "#b45232",
    "property_price_range": "909 - 1199",
    "property_price_min": "909",
    "property_price_max": "1199",
    "property_bedrooms_range": "1 - 2",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "2",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "495 - 900",
    "property_short_description": "Welcome to Chardonnay in Tulsa, Oklahoma, where stylish one and two-bedroom apartments offer comfort and convenience. Dive into refreshing pool days, unwind in the clubhouse, or savor evenings on your private balcony. With amenities like high-speed internet, a pet play area, and modern kitchens, your perfect home awaits. Schedule a tour today! Prefer to explore on your own time? Self-guided tours are available.",
    "property_type": "Apartments",
    "property_total_units": "200",
    "property_website_url": "https://www.caseusa.com/apartments/ok/tulsa/chardonnay/",
    "property_company_name": "Case & Associates",
    "_slug": "chardonnay",
    "_stateSlug": "ok",
    "_citySlug": "tulsa"
  },
  {
    "multihub_property_id": "6767906449165592",
    "multihub_company_id": "5767906449162419",
    "property_name": "Chimneys Apts.",
    "property_slug": "chimneys-apts",
    "property_address": "200 N. Festival",
    "property_address_1": "200 N. Festival",
    "property_address_city": "El Paso",
    "property_address_state": "TX",
    "property_address_zip": "79912",
    "property_address_latitude": "31.8196",
    "property_address_longitude": "-106.5109",
    "property_phone": "(915) 284-8909",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019fb44b-406a-7587-807f-492f3abc4562.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019cfb3a-e7b6-76a8-8744-14bceb05c165.webp",
    "property_primary_color": "#9b6e64",
    "property_price_range": "1144 - 1449",
    "property_price_min": "1144",
    "property_price_max": "1449",
    "property_bedrooms_range": "1 - 2",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "2",
    "property_bathrooms_range": "1 - 1",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "1",
    "property_sqft_range": "620 - 800",
    "property_short_description": "Welcome to Chimneys Apts. in sunny El Paso, where modern living meets comfort. Choose from spacious one and two-bedroom floor plans, and enjoy exceptional amenities like a refreshing pool, fitness center, and pet-friendly spaces. Elevate your lifestyle in our vibrant community—check availability or schedule a tour today! Prefer to explore on your own time? Self-guided tours are available.",
    "property_type": "Apartments",
    "property_total_units": "224",
    "property_website_url": "https://www.caseusa.com/apartments/tx/el-paso/chimneys-apts/",
    "property_company_name": "Case & Associates",
    "_slug": "chimneys-apts",
    "_stateSlug": "tx",
    "_citySlug": "el-paso"
  },
  {
    "multihub_property_id": "6767906449165593",
    "multihub_company_id": "5767906449162419",
    "property_name": "Chisholm Pointe",
    "property_slug": "chisholm-pointe",
    "property_address": "1721 NW 115th",
    "property_address_1": "1721 NW 115th",
    "property_address_city": "Oklahoma City",
    "property_address_state": "OK",
    "property_address_zip": "73120",
    "property_address_latitude": "35.5869",
    "property_address_longitude": "-97.5444",
    "property_phone": "(405) 645-6515",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019fb44b-3087-755f-ad09-52b5126369b2.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019cfb3b-802f-77e1-8046-e507fd4e26af.webp",
    "property_primary_color": "#000000",
    "property_price_range": "1340 - 1980",
    "property_price_min": "1340",
    "property_price_max": "1980",
    "property_bedrooms_range": "1 - 3",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "3",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "683 - 1355",
    "property_short_description": "Welcome to Chisholm Pointe in vibrant Oklahoma City, where modern living meets serene outdoor escapes. Choose from our stylish one, two, or three-bedroom floor plans, and enjoy exceptional amenities like a resort-style swimming pool, fire pits, and a dog park. Experience comfortable living tailored to you—explore your future home today! Prefer to explore on your own time? Self-guided tours are available.",
    "property_type": "Apartments",
    "property_total_units": "216",
    "property_website_url": "https://www.caseusa.com/apartments/ok/oklahoma-city/chisholm-pointe/",
    "property_company_name": "Case & Associates",
    "_slug": "chisholm-pointe",
    "_stateSlug": "ok",
    "_citySlug": "oklahoma-city"
  },
  {
    "multihub_property_id": "6767906449165594",
    "multihub_company_id": "5767906449162419",
    "property_name": "Cimarron Pointe Apts.",
    "property_slug": "cimarron-pointe-apts.",
    "property_address": "8301 North Council Road",
    "property_address_1": "8301 North Council Road",
    "property_address_city": "Oklahoma City",
    "property_address_state": "OK",
    "property_address_zip": "73132",
    "property_address_latitude": "35.5561",
    "property_address_longitude": "-97.6571",
    "property_phone": "(405) 963-2716",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019cfb3c-5ce1-7459-afab-b955ada6f9a0.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019cfb3c-4a25-762c-8303-20e2688b5299.webp",
    "property_primary_color": "#702d1a",
    "property_price_range": "769 - 1189",
    "property_price_min": "769",
    "property_price_max": "1189",
    "property_bedrooms_range": "1 - 2",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "2",
    "property_bathrooms_range": "1 - 2.5",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2.5",
    "property_sqft_range": "550 - 1160",
    "property_short_description": "At Cimarron Pointe Apts. in Oklahoma City, comfort meets convenience. Choose from spacious one, two, or three-bedroom floor plans while enjoying amenities like a refreshing pool, a cozy clubhouse, and a dog park. Embrace a lifestyle where modern living and community spirit thrive. Your ideal home awaits! Prefer to explore on your own time? Self-guided tours are available.",
    "property_type": "Apartments",
    "property_total_units": "252",
    "property_website_url": "https://www.caseusa.com/apartments/ok/oklahoma-city/cimarron-pointe/",
    "property_company_name": "Case & Associates",
    "_slug": "cimarron-pointe-apts",
    "_stateSlug": "ok",
    "_citySlug": "oklahoma-city"
  },
  {
    "multihub_property_id": "6767906449165595",
    "multihub_company_id": "5767906449162419",
    "property_name": "Cimarron Trails Apts.",
    "property_slug": "cimarron-trails-apts.",
    "property_address": "3100 Rock Creek Trail",
    "property_address_1": "3100 Rock Creek Trail",
    "property_address_city": "Norman",
    "property_address_state": "OK",
    "property_address_zip": "73072",
    "property_address_latitude": "35.2466",
    "property_address_longitude": "-97.4871",
    "property_phone": "(405) 972-3513",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019cfb3e-252d-75de-894e-3dbbdda4b34a.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019cfb3c-dc82-70ef-be89-6ae0ab72a87b.webp",
    "property_primary_color": "#3f4040",
    "property_price_range": "949 - 1459",
    "property_price_min": "949",
    "property_price_max": "1459",
    "property_bedrooms_range": "1 - 3",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "3",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "550 - 1200",
    "property_short_description": "Welcome to Cimarron Trails Apartments in Norman, Oklahoma, where comfort meets convenience. Choose from thoughtfully designed one, two, or three-bedroom floor plans and enjoy amenities like a refreshing pool, tennis court, and scenic walking trails. Elevate your lifestyle—find your new home today and schedule a tour! Prefer to explore on your own time? Self-guided tours are available.",
    "property_type": "Apartments",
    "property_total_units": "228",
    "property_website_url": "https://www.caseusa.com/apartments/ok/norman/cimarron-trails/",
    "property_company_name": "Case & Associates",
    "_slug": "cimarron-trails-apts",
    "_stateSlug": "ok",
    "_citySlug": "norman"
  },
  {
    "multihub_property_id": "6767906449165596",
    "multihub_company_id": "5767906449162419",
    "property_name": "Cottages at Crestview",
    "property_slug": "cottages-at-crestview",
    "property_address": "110 N 127th St E",
    "property_address_1": "110 N 127th St E",
    "property_address_city": "Wichita",
    "property_address_state": "KS",
    "property_address_zip": "67206",
    "property_address_latitude": "37.6881",
    "property_address_longitude": "-97.1889",
    "property_phone": "(316) 745-2994",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3c-4ce4-71fe-91d3-ddb4737d3be8.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/019cfb3c-e573-7027-95fd-6ccc2975a6fd.webp",
    "property_primary_color": "#324d58",
    "property_price_range": "1204 - 1704",
    "property_price_min": "1204",
    "property_price_max": "1704",
    "property_bedrooms_range": "1 - 2",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "2",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "789 - 1267",
    "property_short_description": "Welcome to Cottages at Crestview in Wichita, Kansas, where comfort meets convenience. Choose from spacious one, two, or three-bedroom floor plans, and enjoy amenities like a sparkling pool, modern fitness center, and a delightful dog park. Your ideal home awaits—browse our availability or schedule a tour today! Prefer to explore on your own time? Self-guided tours are available.",
    "property_type": "Apartments",
    "property_total_units": "348",
    "property_website_url": "https://www.caseusa.com/apartments/ks/wichita/cottages-at-crestview/",
    "property_company_name": "Case & Associates",
    "_slug": "cottages-at-crestview",
    "_stateSlug": "ks",
    "_citySlug": "wichita"
  },
  {
    "multihub_property_id": "6767906449165597",
    "multihub_company_id": "5767906449162419",
    "property_name": "Council Place Apartments",
    "property_slug": "council-place-apartments",
    "property_address": "10800 North Council Road",
    "property_address_1": "10800 North Council Road",
    "property_address_city": "Oklahoma City",
    "property_address_state": "OK",
    "property_address_zip": "73162",
    "property_address_latitude": "35.579",
    "property_address_longitude": "-97.6554",
    "property_phone": "(405) 342-8301",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165597/019cfb3e-7c4b-71e9-9237-feea426d41c5.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165597/019cfb3d-5035-71c5-9326-d899d1573175.webp",
    "property_primary_color": "#385364",
    "property_price_range": "859 - 1179",
    "property_price_min": "859",
    "property_price_max": "1179",
    "property_bedrooms_range": "1 - 3",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "3",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "700 - 1010",
    "property_short_description": "Welcome to Council Place Apartments in vibrant Oklahoma City! Choose from charming one-, two-, or three-bedroom floor plans, and enjoy amenities like a refreshing pool, a state-of-the-art fitness center, and a cozy clubhouse. Your ideal home awaits—explore our availability or schedule a tour today!",
    "property_type": "Apartments",
    "property_total_units": "256",
    "property_website_url": "https://www.caseusa.com/apartments/ok/oklahoma-city/council-place/",
    "property_company_name": "Case & Associates",
    "_slug": "council-place-apartments",
    "_stateSlug": "ok",
    "_citySlug": "oklahoma-city"
  },
  {
    "multihub_property_id": "6767906449165598",
    "multihub_company_id": "5767906449162419",
    "property_name": "Country Hollow Apartments",
    "property_slug": "country-hollow-apartments",
    "property_address": "4605 East 80th Street",
    "property_address_1": "4605 East 80th Street",
    "property_address_city": "Tulsa",
    "property_address_state": "OK",
    "property_address_zip": "74136",
    "property_address_latitude": "36.0494",
    "property_address_longitude": "-95.9241",
    "property_phone": "(539) 328-7085",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019fb44b-484e-7702-98c7-cca33bd53464.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/01a0cf36-c462-705e-82ce-5c333540df27.webp",
    "property_primary_color": "#324d58",
    "property_price_range": "789 - 849",
    "property_price_min": "789",
    "property_price_max": "849",
    "property_bedrooms_range": "1 - 1",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "1",
    "property_bathrooms_range": "1 - 1",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "1",
    "property_sqft_range": "500 - 700",
    "property_short_description": "<p>Country Hollow Apartments in Tulsa, Oklahoma, invites you to experience stylish living with one- and two-bedroom floor plans. Enjoy amenities like a sparkling pool, fitness center, and tennis court, all nestled near scenic walking trails. Embrace comfort and convenience—your perfect home awaits. Browse our availability or schedule a tour today! Prefer to explore on your own time? Self-guided tours are available.</p>",
    "property_type": "Apartments",
    "property_total_units": "280",
    "property_website_url": "https://www.caseusa.com/apartments/ok/tulsa/country-hollow/",
    "property_company_name": "Case & Associates",
    "_slug": "country-hollow-apartments",
    "_stateSlug": "ok",
    "_citySlug": "tulsa"
  },
  {
    "multihub_property_id": "6767906449165599",
    "multihub_company_id": "5767906449162419",
    "property_name": "Creekwood Apartments",
    "property_slug": "creekwood-apartments",
    "property_address": "8418 S. 77th E. Ave.",
    "property_address_1": "8418 S. 77th E. Ave.",
    "property_address_city": "Tulsa",
    "property_address_state": "OK",
    "property_address_zip": "74133",
    "property_address_latitude": "36.0407",
    "property_address_longitude": "-95.8873",
    "property_phone": "(539) 212-4189",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019fb44b-4f80-7574-82a0-ddad5c975fb0.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019cfb3d-a7ec-763d-8c44-281e4ad06ca9.webp",
    "property_primary_color": "#5c7375",
    "property_price_range": "969 - 1219",
    "property_price_min": "969",
    "property_price_max": "1219",
    "property_bedrooms_range": "1 - 2",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "2",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "630 - 1000",
    "property_short_description": "Nestled in the heart of Tulsa, Creekwood Apartments offers a vibrant lifestyle with thoughtfully designed one and two-bedroom floor plans. Enjoy resort-style amenities like a sparkling pool, fitness center, and inviting clubhouse. Elevate your living experience—schedule a tour and uncover your perfect sanctuary in our welcoming community today! Prefer to explore on your own time? Self-guided tours are available.",
    "property_type": "Apartments",
    "property_total_units": "651",
    "property_website_url": "https://www.caseusa.com/apartments/ok/tulsa/creekwood/",
    "property_company_name": "Case & Associates",
    "_slug": "creekwood-apartments",
    "_stateSlug": "ok",
    "_citySlug": "tulsa"
  },
  {
    "multihub_property_id": "6767906449165600",
    "multihub_company_id": "5767906449162419",
    "property_name": "Cross Timber",
    "property_slug": "cross-timber",
    "property_address": "10700 S. May Ave.",
    "property_address_1": "10700 S. May Ave.",
    "property_address_city": "Oklahoma City",
    "property_address_state": "OK",
    "property_address_zip": "73170",
    "property_address_latitude": "35.3614",
    "property_address_longitude": "-97.56421",
    "property_phone": "(405) 287-2987",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019cfb3f-d3c6-7076-bbe5-071edd09274a.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019cfb3e-af04-706f-a16b-61338677b4ad.webp",
    "property_primary_color": "#3d3d3f",
    "property_price_range": "1239 - 1579",
    "property_price_min": "1239",
    "property_price_max": "1579",
    "property_bedrooms_range": "2 - 3",
    "property_bedrooms_min": "2",
    "property_bedrooms_max": "3",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "929 - 1204",
    "property_short_description": "Welcome to Cross Timber, where comfort meets community in Oklahoma City. Choose between spacious two and three-bedroom floor plans, all adorned with modern amenities—like a pool, fitness center, and pet play area. Enjoy social activities and online services while basking in luxury. Your perfect home awaits! Prefer to explore on your own time? Self-guided tours are available.",
    "property_type": "Apartments",
    "property_total_units": "150",
    "property_website_url": "https://www.caseusa.com/apartments/ok/oklahoma-city/cross-timber/",
    "property_company_name": "Case & Associates",
    "_slug": "cross-timber",
    "_stateSlug": "ok",
    "_citySlug": "oklahoma-city"
  },
  {
    "multihub_property_id": "6767906449165601",
    "multihub_company_id": "5767906449162419",
    "property_name": "Crown Chase Apts",
    "property_slug": "crown-chase-apts",
    "property_address": "1010 North Ridge Road",
    "property_address_1": "1010 N Ridge Rd",
    "property_address_city": "Wichita",
    "property_address_state": "KS",
    "property_address_zip": "67212",
    "property_address_latitude": "37.7005",
    "property_address_longitude": "-97.426",
    "property_phone": "(316) 402-2837",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019cfb3f-c635-7308-ba24-5dc7d2c2c24d.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165601/019cfb3e-a7dc-771c-b092-320e28280537.webp",
    "property_primary_color": "#3d3d3f",
    "property_price_range": "994 - 1284",
    "property_price_min": "994",
    "property_price_max": "1284",
    "property_bedrooms_range": "1 - 2",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "2",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "738 - 978",
    "property_short_description": "At Crown Chase Apartments in Wichita, Kansas, vibrant living meets modern convenience. Choose from spacious one- and two-bedroom floor plans and enjoy amenities like a sparkling pool, fitness center, and tranquil walking trails. Experience community living with on-site management, gated access, and delightful lake views—your new home awaits! Prefer to explore on your own time? Self-guided tours are available.",
    "property_type": "Apartments",
    "property_total_units": "384",
    "property_website_url": "https://www.caseusa.com/apartments/ks/wichita/crown-chase/",
    "property_company_name": "Case & Associates",
    "_slug": "crown-chase-apts",
    "_stateSlug": "ks",
    "_citySlug": "wichita"
  },
  {
    "multihub_property_id": "6767906449165602",
    "multihub_company_id": "5767906449162419",
    "property_name": "Crown Pointe Apartments",
    "property_slug": "crown-pointe-apartments",
    "property_address": "12600 North MacArthur",
    "property_address_1": "12600 North MacArthur",
    "property_address_city": "Oklahoma City",
    "property_address_state": "OK",
    "property_address_zip": "73142",
    "property_address_latitude": "35.5989",
    "property_address_longitude": "-97.6202",
    "property_phone": "(405) 643-8198",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019cfb40-5b47-7420-ba4f-e0f360470bb7.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019f1f97-dcc4-74df-8748-595de36ae70b.webp",
    "property_primary_color": "#73705e",
    "property_price_range": "899 - 1179",
    "property_price_min": "899",
    "property_price_max": "1179",
    "property_bedrooms_range": "1 - 2",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "2",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "800 - 1000",
    "property_short_description": "<p>At Crown Pointe Apartments in Oklahoma City, find your perfect blend of comfort and convenience. Choose from spacious one or two-bedroom floor plans featuring modern amenities like a sparkling pool, fitness center, and stylish clubhouse. Embrace a vibrant lifestyle—schedule your tour today to see your future home! Prefer to explore on your own time? Self-guided tours are available.</p>",
    "property_type": "Apartments",
    "property_total_units": "360",
    "property_website_url": "https://www.caseusa.com/apartments/ok/oklahoma-city/crown-pointe/",
    "property_company_name": "Case & Associates",
    "_slug": "crown-pointe-apartments",
    "_stateSlug": "ok",
    "_citySlug": "oklahoma-city"
  },
  {
    "multihub_property_id": "6767906449165603",
    "multihub_company_id": "5767906449162419",
    "property_name": "Cypress Crossing",
    "property_slug": "cypress-crossing",
    "property_address": "10015 N. Owasso Expressway",
    "property_address_1": "10015 N. Owasso Expressway",
    "property_address_city": "Owasso",
    "property_address_state": "OK",
    "property_address_zip": "74055",
    "property_address_latitude": "36.2989",
    "property_address_longitude": "-95.8229",
    "property_phone": "(539) 212-3987",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019cfb3e-c2cc-743e-8515-781515a1357e.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019cfb3f-855c-7037-b4a0-60a267a7fd7f.webp",
    "property_primary_color": "#00aca0",
    "property_price_range": "1204 - 2119",
    "property_price_min": "1204",
    "property_price_max": "2119",
    "property_bedrooms_range": "1 - 3",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "3",
    "property_bathrooms_range": "1 - 2.5",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2.5",
    "property_sqft_range": "789 - 1473",
    "property_short_description": "Welcome to Cypress Crossing in Owasso, Oklahoma—a vibrant community where comfort meets style. Choose from spacious one, two, or three-bedroom floor plans, equipped with modern amenities like a refreshing pool, fitness center, and dog park. Don’t miss the chance to experience your ideal lifestyle—schedule a tour today! Prefer to explore on your own time? Self-guided tours are available.",
    "property_type": "Apartments",
    "property_total_units": "366",
    "property_website_url": "https://www.caseusa.com/apartments/ok/owasso/cypress-crossing/",
    "property_company_name": "Case & Associates",
    "_slug": "cypress-crossing",
    "_stateSlug": "ok",
    "_citySlug": "owasso"
  },
  {
    "multihub_property_id": "6767906449165604",
    "multihub_company_id": "5767906449162419",
    "property_name": "Double Tree Apts.",
    "property_slug": "double-tree-apts.",
    "property_address": "200 North Mesa Hills Drive",
    "property_address_1": "200 North Mesa Hills Drive",
    "property_address_city": "El Paso",
    "property_address_state": "TX",
    "property_address_zip": "79912",
    "property_address_latitude": "31.8249",
    "property_address_longitude": "-106.51866",
    "property_phone": "(915) 335-6857",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019cfb3f-5093-76fb-bc3c-e439e0a04eb9.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019cfb3f-474b-705a-afc6-b0109a1808ba.webp",
    "property_primary_color": "#b8b1a8",
    "property_price_range": "949 - 1319",
    "property_price_min": "949",
    "property_price_max": "1319",
    "property_bedrooms_range": "1 - 2",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "2",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "491 - 920",
    "property_short_description": "Welcome to Double Tree Apts., where comfort meets convenience in El Paso, Texas. Choose from spacious one or two-bedroom layouts, and enjoy premium amenities like a refreshing pool, inviting sundeck, and on-site business center. Embrace a vibrant community life, complete with planned social activities and nearby walking trails. Prefer to explore on your own time? Self-guided tours are available.",
    "property_type": "Apartments",
    "property_total_units": "284",
    "property_website_url": "https://www.caseusa.com/apartments/tx/el-paso/double-tree/",
    "property_company_name": "Case & Associates",
    "_slug": "double-tree-apts",
    "_stateSlug": "tx",
    "_citySlug": "el-paso"
  },
  {
    "multihub_property_id": "6767906449165605",
    "multihub_company_id": "5767906449162419",
    "property_name": "Fountain Lake",
    "property_slug": "fountain-lake",
    "property_address": "14025 N. Eastern Ave.",
    "property_address_1": "14025 N. Eastern Ave.",
    "property_address_city": "Edmond",
    "property_address_state": "OK",
    "property_address_zip": "73013",
    "property_address_latitude": "35.6125",
    "property_address_longitude": "-97.4809",
    "property_phone": "(405) 645-9102",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019cfb41-c632-712e-abaa-3f645ec7c397.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165605/019cfb40-9680-739f-a5a5-8a5fdc299fae.webp",
    "property_primary_color": "#3d3d3f",
    "property_price_range": "1099 - 1499",
    "property_price_min": "1099",
    "property_price_max": "1499",
    "property_bedrooms_range": "1 - 2",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "2",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "789 - 1110",
    "property_short_description": "Welcome to Fountain Lake in Edmond, Oklahoma, where comfort meets convenience. Choose from spacious one- and two-bedroom floor plans, and enjoy resort-style amenities, including a refreshing pool, fitness center, and tranquil courtyard. Your ideal home awaits—check our availability or schedule a tour today! Prefer to explore on your own time? Self-guided tours are available.",
    "property_type": "Apartments",
    "property_total_units": "530",
    "property_website_url": "https://www.caseusa.com/apartments/ok/edmond/fountain-lake/",
    "property_company_name": "Case & Associates",
    "_slug": "fountain-lake",
    "_stateSlug": "ok",
    "_citySlug": "edmond"
  },
  {
    "multihub_property_id": "6767906449165606",
    "multihub_company_id": "5767906449162419",
    "property_name": "High Ridge Apts.",
    "property_slug": "high-ridge-apts.",
    "property_address": "9353 Viscount",
    "property_address_1": "9353 Viscount",
    "property_address_city": "El Paso",
    "property_address_state": "TX",
    "property_address_zip": "79925",
    "property_address_latitude": "31.7708",
    "property_address_longitude": "-106.3627",
    "property_phone": "(915) 223-6677",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019dbbe7-7806-7029-9676-f52dbc3dd031.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019cfb40-67ed-75cf-912a-f1cf70580c03.webp",
    "property_primary_color": "#3d3d3f",
    "property_price_range": "1125 - 1384",
    "property_price_min": "1125",
    "property_price_max": "1384",
    "property_bedrooms_range": "1 - 2",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "2",
    "property_bathrooms_range": "1 - 1",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "1",
    "property_sqft_range": "646 - 829",
    "property_short_description": "Experience a vibrant lifestyle at High Ridge Apts. in sunny El Paso, Texas. Choose from spacious one- and two-bedroom floor plans, complete with modern amenities like a sparkling pool, fitness center, and picnic area. Your ideal home awaits—explore our availability or schedule a tour today! Prefer to explore on your own time? Self-guided tours are available.",
    "property_type": "Apartments",
    "property_total_units": "296",
    "property_website_url": "https://www.caseusa.com/apartments/tx/el-paso/high-ridge/",
    "property_company_name": "Case & Associates",
    "_slug": "high-ridge-apts",
    "_stateSlug": "tx",
    "_citySlug": "el-paso"
  },
  {
    "multihub_property_id": "6767906449165607",
    "multihub_company_id": "5767906449162419",
    "property_name": "Hunter's Ridge Apts.",
    "property_slug": "hunter's-ridge-apts.",
    "property_address": "9211 North Council Road",
    "property_address_1": "9211 North Council Road",
    "property_address_city": "Oklahoma City",
    "property_address_state": "OK",
    "property_address_zip": "73132",
    "property_address_latitude": "35.5636",
    "property_address_longitude": "-97.6578",
    "property_phone": "(405) 442-4347",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019cfb41-34a3-71ee-b967-565268701afb.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019cfb40-cea2-7478-9b09-4cf1aecd01e5.webp",
    "property_primary_color": "#3d3d3f",
    "property_price_range": "744 - 1159",
    "property_price_min": "744",
    "property_price_max": "1159",
    "property_bedrooms_range": "1 - 2",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "2",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "525 - 1078",
    "property_short_description": "Welcome to Hunter's Ridge Apts., where comfort meets convenience in the heart of Oklahoma City. Choose from spacious one- or two-bedroom floor plans, each adorned with modern amenities. Unwind by the pool, gather in the clubhouse, or enjoy our inviting picnic areas. Your new home awaits—schedule a tour today! Prefer to explore on your own time? Self-guided tours are available.",
    "property_type": "Apartments",
    "property_total_units": "212",
    "property_website_url": "https://www.caseusa.com/apartments/ok/oklahoma-city/hunters-ridge/",
    "property_company_name": "Case & Associates",
    "_slug": "hunter-s-ridge-apts",
    "_stateSlug": "ok",
    "_citySlug": "oklahoma-city"
  },
  {
    "multihub_property_id": "6767906449165608",
    "multihub_company_id": "5767906449162419",
    "property_name": "Icon at Lubbock",
    "property_slug": "icon-at-lubbock",
    "property_address": "6216 66th Street",
    "property_address_1": "6216 66th Street",
    "property_address_city": "Lubbock",
    "property_address_state": "TX",
    "property_address_zip": "79424",
    "property_address_latitude": "33.5348",
    "property_address_longitude": "-101.9534",
    "property_phone": "(806) 230-5109",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165608/019d20af-38ec-7339-af10-29b25d8eeaf1.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165608/019cfb41-196e-761b-951e-db598e5625b4.webp",
    "property_primary_color": "#2f2f30",
    "property_price_range": "1049 - 1299",
    "property_price_min": "1049",
    "property_price_max": "1299",
    "property_bedrooms_range": "1 - 2",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "2",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "789 - 1050",
    "property_short_description": "Elevate your lifestyle at Icon at Lubbock, where stylish one and two-bedroom floor plans meet an array of luxurious amenities. Dive into our sparkling pool, stay fit in the gym, or unwind in our cozy lounge. Your ideal home awaits—browse availability or schedule a tour today!",
    "property_type": "Apartments",
    "property_total_units": "288",
    "property_website_url": "https://www.caseusa.com/apartments/tx/lubbock/icon-at-lubbock/",
    "property_company_name": "Case & Associates",
    "_slug": "icon-at-lubbock",
    "_stateSlug": "tx",
    "_citySlug": "lubbock"
  },
  {
    "multihub_property_id": "6767906449165609",
    "multihub_company_id": "5767906449162419",
    "property_name": "Lexington Park",
    "property_slug": "lexington-park",
    "property_address": "7601 Vestal Blvd",
    "property_address_1": "7601 Vestal Blvd",
    "property_address_city": "North Little Rock",
    "property_address_state": "AR",
    "property_address_zip": "72113",
    "property_address_latitude": "34.8256",
    "property_address_longitude": "-92.3691",
    "property_phone": "(501) 459-9783",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165609/019cfb43-0488-713d-8b07-aabc43e5946b.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165609/019cfb41-f566-758d-b845-e1afff905da2.webp",
    "property_primary_color": "#463567",
    "property_price_range": "909 - 1359",
    "property_price_min": "909",
    "property_price_max": "1359",
    "property_bedrooms_range": "1 - 3",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "3",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "804 - 1274",
    "property_short_description": "Welcome to Lexington Park in Maumelle, Arkansas—a vibrant apartment community offering one to three-bedroom floor plans designed for comfort and convenience. Enjoy resort-style amenities like a refreshing pool, energizing fitness center, and inviting clubhouse. With stunning interiors and a pet-friendly atmosphere, your perfect home awaits!",
    "property_type": "Apartments",
    "property_total_units": "288",
    "property_website_url": "https://www.caseusa.com/apartments/ar/north-little-rock/lexington-park/",
    "property_company_name": "Case & Associates",
    "_slug": "lexington-park",
    "_stateSlug": "ar",
    "_citySlug": "north-little-rock"
  },
  {
    "multihub_property_id": "6767906449165610",
    "multihub_company_id": "5767906449162419",
    "property_name": "Mark Apts.",
    "property_slug": "mark-apts.",
    "property_address": "711 Lake Harbour Drive",
    "property_address_1": "711 Lake Harbour Dr",
    "property_address_city": "Ridgeland",
    "property_address_state": "MS",
    "property_address_zip": "39157",
    "property_address_latitude": "32.4121",
    "property_address_longitude": "-90.1137",
    "property_phone": "(601) 574-5389",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019d20af-318a-74fa-83ba-fa7eae597807.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019cfb41-f49c-74fd-9112-089b8a34efcf.webp",
    "property_primary_color": "#a34123",
    "property_price_range": "1284 - 1394",
    "property_price_min": "1284",
    "property_price_max": "1394",
    "property_bedrooms_range": "1 - 2",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "2",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "850 - 1100",
    "property_short_description": "At Mark Apts. in Ridgeland, Mississippi, your ideal home awaits with spacious one and two-bedroom floor plans. Enjoy a refreshing dip in the pool, relax in the clubhouse, or serve up some fun on our tennis court. Experience modern comforts, including air conditioning, walk-in closets, and high-speed internet. Your perfect lifestyle starts here! Prefer to explore on your own time? Self-guided tours are available.",
    "property_type": "Apartments",
    "property_total_units": "256",
    "property_website_url": "https://www.caseusa.com/apartments/ms/ridgeland/the-mark/",
    "property_company_name": "Case & Associates",
    "_slug": "mark-apts",
    "_stateSlug": "ms",
    "_citySlug": "ridgeland"
  },
  {
    "multihub_property_id": "6767906449165611",
    "multihub_company_id": "5767906449162419",
    "property_name": "Mission Point",
    "property_slug": "mission-point",
    "property_address": "2900 South Service Road",
    "property_address_1": "2900 South Service Road",
    "property_address_city": "Moore",
    "property_address_state": "OK",
    "property_address_zip": "73160",
    "property_address_latitude": "35.3117",
    "property_address_longitude": "-97.4873",
    "property_phone": "(405) 242-1223",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019cfb42-1551-7489-a7ce-dfb5b9c3de6a.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165611/019cfb42-47f4-73ed-b4af-f7e27882e339.webp",
    "property_primary_color": "#16618e",
    "property_price_range": "1159 - 1439",
    "property_price_min": "1159",
    "property_price_max": "1439",
    "property_bedrooms_range": "1 - 2",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "2",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "789 - 1176",
    "property_short_description": "At Mission Point in Moore, Oklahoma, experience the perfect blend of comfort and style. Choose from spacious one- and two-bedroom floor plans, enjoy a refreshing dip in the pool, or unwind in our vibrant clubhouse. With amenities like a pet play area and walking trails, your ideal lifestyle awaits. Prefer to explore on your own time? Self-guided tours are available.",
    "property_type": "Apartments",
    "property_total_units": "628",
    "property_website_url": "https://www.caseusa.com/apartments/ok/moore/mission-point/",
    "property_company_name": "Case & Associates",
    "_slug": "mission-point",
    "_stateSlug": "ok",
    "_citySlug": "moore"
  },
  {
    "multihub_property_id": "6767906449165612",
    "multihub_company_id": "5767906449162419",
    "property_name": "Mountain Village Apts.",
    "property_slug": "mountain-village-apts.",
    "property_address": "5890 Bandolero Drive",
    "property_address_1": "5890 Bandolero Drive",
    "property_address_city": "El Paso",
    "property_address_state": "TX",
    "property_address_zip": "79912",
    "property_address_latitude": "31.8565",
    "property_address_longitude": "-106.5172",
    "property_phone": "(915) 284-8916",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019cfb43-da81-71cf-b420-8400aa0187a6.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165612/019cfb42-cf5d-724b-85f2-0e595411e842.webp",
    "property_primary_color": "#504942",
    "property_price_range": "1055 - 1055",
    "property_price_min": "1055",
    "property_price_max": "1055",
    "property_bedrooms_range": "2",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "1",
    "property_bathrooms_range": "1 - 1",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "1",
    "property_sqft_range": "700 - 700",
    "property_short_description": "At Mountain Village Apts. in El Paso, enjoy spacious one and two-bedroom floor plans tailored for comfort. Indulge in resort-style amenities like our sparkling pool, fitness center, and a vibrant clubhouse. With pet-friendly features and serene outdoor spaces, your ideal home awaits. Start your journey to a new lifestyle today! Prefer to explore on your own time? Self-guided tours are available.",
    "property_type": "Apartments",
    "property_total_units": "288",
    "property_website_url": "https://www.caseusa.com/apartments/tx/el-paso/mountain-village-apts/",
    "property_company_name": "Case & Associates",
    "_slug": "mountain-village-apts",
    "_stateSlug": "tx",
    "_citySlug": "el-paso"
  },
  {
    "multihub_property_id": "6767906449165613",
    "multihub_company_id": "5767906449162419",
    "property_name": "Newport Amarillo Apts",
    "property_slug": "newport-amarillo-apts",
    "property_address": "6100 Southwest 45th",
    "property_address_1": "6100 Southwest 45th",
    "property_address_city": "Amarillo",
    "property_address_state": "TX",
    "property_address_zip": "79109",
    "property_address_latitude": "35.1624",
    "property_address_longitude": "-101.904",
    "property_phone": "(806) 304-7189",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb43-f485-775b-8778-be9ac82bb810.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb42-c5e4-76b5-86ad-6c691a714f40.webp",
    "property_primary_color": "#54504a",
    "property_price_range": "1084 - 1259",
    "property_price_min": "1084",
    "property_price_max": "1259",
    "property_bedrooms_range": "1 - 2",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "2",
    "property_bathrooms_range": "1 - 1.5",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "1.5",
    "property_sqft_range": "624 - 840",
    "property_short_description": "Welcome to Newport Amarillo Apts, where comfort meets convenience in the heart of Amarillo, Texas. Choose from spacious one or two-bedroom floor plans, and enjoy exceptional amenities including a shimmering pool, dog park, and inviting clubhouse. Schedule your tour today and envision your perfect home! Prefer to explore on your own time? Self-guided tours are available.",
    "property_type": "Apartments",
    "property_total_units": "216",
    "property_website_url": "https://www.caseusa.com/apartments/tx/amarillo/newport/",
    "property_company_name": "Case & Associates",
    "_slug": "newport-amarillo-apts",
    "_stateSlug": "tx",
    "_citySlug": "amarillo"
  },
  {
    "multihub_property_id": "6767906449165614",
    "multihub_company_id": "5767906449162419",
    "property_name": "Nickel Creek Apts",
    "property_slug": "nickel-creek-apts",
    "property_address": "7805 South Union Avenue",
    "property_address_1": "7805 South Union Avenue",
    "property_address_city": "Tulsa",
    "property_address_state": "Oklahoma",
    "property_address_zip": "74132",
    "property_address_latitude": "36.0509",
    "property_address_longitude": "-96.0108",
    "property_phone": "(539) 208-8753",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019cfb42-e048-75f7-b3e7-ed568132432b.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019cfb43-3fb2-71db-b3e4-38585067baf7.webp",
    "property_primary_color": "#3d3d3f",
    "property_price_range": "1129 - 1469",
    "property_price_min": "1129",
    "property_price_max": "1399",
    "property_bedrooms_range": "1 - 2",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "2",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "789 - 1050",
    "property_short_description": "Welcome to Nickel Creek Apts in Tulsa, Oklahoma—a vibrant community featuring stylish one and two-bedroom floor plans. Your furry friend will love our spacious Bark Park, perfect for playdates. Find your new home today—browse our availability or schedule a tour to experience the charm of Nickel Creek! Prefer to explore on your own time? Self-guided tours are available.",
    "property_type": "Apartments",
    "property_total_units": "304",
    "property_website_url": "https://www.caseusa.com/apartments/ok/tulsa/nickel-creek/",
    "property_company_name": "Case & Associates",
    "_slug": "nickel-creek-apts",
    "_stateSlug": "ok",
    "_citySlug": "tulsa"
  },
  {
    "multihub_property_id": "6767906449165615",
    "multihub_company_id": "5767906449162419",
    "property_name": "Park at Coulter",
    "property_slug": "park-at-coulter",
    "property_address": "5040 South Coulter St.",
    "property_address_1": "5040 South Coulter St.",
    "property_address_city": "Amarillo",
    "property_address_state": "TX",
    "property_address_zip": "79119",
    "property_address_latitude": "35.1555",
    "property_address_longitude": "-101.9227",
    "property_phone": "(806) 515-3550",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb45-06cc-725e-8f0c-c7db61a381d3.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/019cfb43-c40f-77a5-94de-5b229f685290.webp",
    "property_primary_color": "#194f90",
    "property_price_range": "1424 - 1620",
    "property_price_min": "1424",
    "property_price_max": "1620",
    "property_bedrooms_range": "1 - 2",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "2",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": " - 1108",
    "property_short_description": "Welcome to Park at Coulter in Amarillo, Texas, where modern living meets convenience. Choose from spacious one- and two-bedroom floor plans, and enjoy luxurious amenities like our welcoming clubhouse, refreshing pool, and vibrant dog park. Elevate your lifestyle—check our availability today or schedule a tour! Prefer to explore on your own time? Self-guided tours are available.",
    "property_type": "Apartments",
    "property_total_units": "262",
    "property_website_url": "https://www.caseusa.com/apartments/tx/amarillo/park-at-coulter/",
    "property_company_name": "Case & Associates",
    "_slug": "park-at-coulter",
    "_stateSlug": "tx",
    "_citySlug": "amarillo"
  },
  {
    "multihub_property_id": "6767906449165616",
    "multihub_company_id": "5767906449162419",
    "property_name": "Park at Tuscany",
    "property_slug": "park-at-tuscany",
    "property_address": "2737 NW 140th Street",
    "property_address_1": "2737 NW 140th Street",
    "property_address_city": "Oklahoma City",
    "property_address_state": "OK",
    "property_address_zip": "73134",
    "property_address_latitude": "35.6149",
    "property_address_longitude": "-97.5625",
    "property_phone": "4053907547",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019cfb44-114e-776f-8551-73ebd683e64d.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165616/019cfb43-a6ae-75ea-9763-a8231c524114.webp",
    "property_primary_color": "#3e543a",
    "property_price_range": "1069 - 1549",
    "property_price_min": "1069",
    "property_price_max": "1549",
    "property_bedrooms_range": "1 - 2",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "2",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "789 - 1176",
    "property_short_description": "At Park at Tuscany in Oklahoma City, luxury meets comfort. Choose from spacious one and two-bedroom floor plans, and unwind by the sparkling pool or in the inviting clubhouse. With an array of modern amenities and a picturesque picnic area, your ideal home awaits. Explore our availability and schedule a tour today! Prefer to explore on your own time? Self-guided tours are available.",
    "property_type": "Apartments",
    "property_total_units": "262",
    "property_website_url": "https://www.caseusa.com/apartments/ok/oklahoma-city/park-at-tuscany/",
    "property_company_name": "Case & Associates",
    "_slug": "park-at-tuscany",
    "_stateSlug": "ok",
    "_citySlug": "oklahoma-city"
  },
  {
    "multihub_property_id": "6767906449165617",
    "multihub_company_id": "5767906449162419",
    "property_name": "Park at Westpointe",
    "property_slug": "park-at-westpointe",
    "property_address": "301 Pointe Parkway Blvd",
    "property_address_1": "301 Pointe Parkway Blvd",
    "property_address_city": "Yukon",
    "property_address_state": "OK",
    "property_address_zip": "73099",
    "property_address_latitude": "35.4619",
    "property_address_longitude": "-97.7207",
    "property_phone": "(405) 783-3140",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d20af-6854-767d-a2bb-cf50e75ece44.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019cfb44-8ace-77fe-8575-5c105932fac2.webp",
    "property_primary_color": "#000000",
    "property_price_range": "1049 - 1449",
    "property_price_min": "1049",
    "property_price_max": "1449",
    "property_bedrooms_range": "1 - 2",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "2",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "789 - 1110",
    "property_short_description": "At Park at Westpointe in Yukon, Oklahoma, your ideal living space awaits. Choose from stylish one and two-bedroom floor plans, and enjoy resort-like amenities such as a sparkling pool, state-of-the-art fitness center, and serene picnic area. Experience comfort and convenience—your new home is just a click away! Prefer to explore on your own time? Self-guided tours are available.",
    "property_type": "Apartments",
    "property_total_units": "520",
    "property_website_url": "https://www.caseusa.com/apartments/ok/yukon/park-at-westpointe/",
    "property_company_name": "Case & Associates",
    "_slug": "park-at-westpointe",
    "_stateSlug": "ok",
    "_citySlug": "yukon"
  },
  {
    "multihub_property_id": "6767906449165618",
    "multihub_company_id": "5767906449162419",
    "property_name": "Patriot Apts.",
    "property_slug": "patriot-apts.",
    "property_address": "4600 Fairbanks",
    "property_address_1": "4600 Fairbanks",
    "property_address_city": "El Paso",
    "property_address_state": "TX",
    "property_address_zip": "79924",
    "property_address_latitude": "31.903",
    "property_address_longitude": "-106.4391",
    "property_phone": "(915) 336-8182",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-2e73-7192-bc47-cd90f31f3e09.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165618/019cfb44-ac8c-7015-a1c2-b632355dee8b.webp",
    "property_primary_color": "#1d2f5d",
    "property_price_range": "1049 - 1545",
    "property_price_min": "1049",
    "property_price_max": "1545",
    "property_bedrooms_range": "1 - 3",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "3",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "655 - 1070",
    "property_short_description": "At Patriot Apts. in vibrant El Paso, Texas, elevate your lifestyle with spacious one, two, and three-bedroom layouts. Enjoy an array of amenities including a refreshing pool, state-of-the-art fitness center, and a welcoming clubhouse. Your perfect home awaits—check availability or schedule your visit today! Prefer to explore on your own time? Self-guided tours are available.",
    "property_type": "Apartments",
    "property_total_units": "320",
    "property_website_url": "https://www.caseusa.com/apartments/tx/el-paso/patriot-apts/",
    "property_company_name": "Case & Associates",
    "_slug": "patriot-apts",
    "_stateSlug": "tx",
    "_citySlug": "el-paso"
  },
  {
    "multihub_property_id": "6767906449165619",
    "multihub_company_id": "5767906449162419",
    "property_name": "Polo Run Apartments",
    "property_slug": "polo-run-apartments",
    "property_address": "7027 South Joplin",
    "property_address_1": "7027 South Joplin",
    "property_address_city": "Tulsa",
    "property_address_state": "OK",
    "property_address_zip": "74136",
    "property_address_latitude": "36.0627",
    "property_address_longitude": "-95.9116",
    "property_phone": "(539) 239-3828",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019fb44b-8bef-7751-a7bd-7c5144c13890.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019cfb45-4906-7542-8939-3709978cf315.webp",
    "property_primary_color": "#6d6c62",
    "property_price_range": "949 - 1334",
    "property_price_min": "949",
    "property_price_max": "1334",
    "property_bedrooms_range": "1 - 2",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "2",
    "property_bathrooms_range": "1 - 2.5",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2.5",
    "property_sqft_range": "700 - 1300",
    "property_short_description": "Welcome to Polo Run Apartments in Tulsa, Oklahoma, where comfort meets convenience. Choose from spacious one and two-bedroom floor plans equipped with modern amenities like a refreshing pool, fitness center, and dog park. Unwind at our clubhouse or explore scenic walking trails—your ideal home awaits! Schedule a tour today! Prefer to explore on your own time? Self-guided tours are available.",
    "property_type": "Apartments",
    "property_total_units": "178",
    "property_website_url": "https://www.caseusa.com/apartments/ok/tulsa/polo-run/",
    "property_company_name": "Case & Associates",
    "_slug": "polo-run-apartments",
    "_stateSlug": "ok",
    "_citySlug": "tulsa"
  },
  {
    "multihub_property_id": "6767906449165620",
    "multihub_company_id": "5767906449162419",
    "property_name": "Portico at Friars Creek Apts",
    "property_slug": "portico-at-friars-creek-apts",
    "property_address": "507 Marlandwood Road",
    "property_address_1": "507 Marlandwood Road",
    "property_address_city": "Temple",
    "property_address_state": "TX",
    "property_address_zip": "76502",
    "property_address_latitude": "31.0609",
    "property_address_longitude": "-97.3607",
    "property_phone": "(254) 876-6429",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019cfb46-5d78-761b-a3eb-1242d40ab171.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165620/019cfb45-9c40-76cf-8048-6602f45c6b43.webp",
    "property_primary_color": "#075699",
    "property_price_range": "1189 - 1719",
    "property_price_min": "1189",
    "property_price_max": "1719",
    "property_bedrooms_range": "1 - 2",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "2",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "789 - 1267",
    "property_short_description": "At Portico at Friars Creek in Temple, Texas, our thoughtfully designed one- and two-bedroom apartments blend comfort with modern amenities. Enjoy a refreshing dip in the pool, energize in the fitness center, or unwind in the cabana. Come see why your perfect home awaits—schedule a tour today! Prefer to explore on your own time? Self-guided tours are available.",
    "property_type": "Apartments",
    "property_total_units": "264",
    "property_website_url": "https://www.caseusa.com/apartments/tx/temple/portico-at-friars-creek-apts/",
    "property_company_name": "Case & Associates",
    "_slug": "portico-at-friars-creek-apts",
    "_stateSlug": "tx",
    "_citySlug": "temple"
  },
  {
    "multihub_property_id": "6767906449165621",
    "multihub_company_id": "5767906449162419",
    "property_name": "Prairie Springs",
    "property_slug": "prairie-springs-i",
    "property_address": "9777 North Council Road",
    "property_address_1": "9777 North Council Road",
    "property_address_city": "Oklahoma City",
    "property_address_state": "OK",
    "property_address_zip": "73162",
    "property_address_latitude": "35.57055",
    "property_address_longitude": "-97.65686",
    "property_phone": "(844) 899-7238",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019cfb46-a140-73e2-a7b2-56d0e9c2d207.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/019cfb45-5f0d-7297-a5d0-030c04bf4e54.webp",
    "property_primary_color": "#660b11",
    "property_price_range": "899 - 1579",
    "property_price_min": "899",
    "property_price_max": "1579",
    "property_bedrooms_range": "1 - 3",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "3",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "692 - 1447",
    "property_short_description": "Welcome to Prairie Springs in Oklahoma City, where comfort meets convenience. Choose from our one, two, or three-bedroom floor plans featuring walk-in closets, vaulted ceilings, and private balconies. Enjoy a laid-back lifestyle with our sparkling pool, fitness center, and dog park. Find your new home today—browse availability or schedule a tour! Prefer to explore on your own time? Self-guided tours are available.",
    "property_type": "Apartments",
    "property_total_units": "462",
    "property_website_url": "https://www.caseusa.com/apartments/ok/oklahoma-city/prairie-springs/",
    "property_company_name": "Case & Associates",
    "_slug": "prairie-springs-i",
    "_stateSlug": "ok",
    "_citySlug": "oklahoma-city"
  },
  {
    "multihub_property_id": "6767906449165622",
    "multihub_company_id": "5767906449162419",
    "property_name": "Raintree Apts",
    "property_slug": "raintree-apartments",
    "property_address": "777 North Silver Springs Blvd",
    "property_address_1": "777 North Silver Springs Blvd",
    "property_address_city": "Wichita",
    "property_address_state": "KS",
    "property_address_zip": "67212",
    "property_address_latitude": "37.6965",
    "property_address_longitude": "-97.4228",
    "property_phone": "(316) 799-0117",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb45-b48e-7104-aed1-5aa17c741f33.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165622/019cfb46-0779-75d0-9f57-ae3a0d38ee40.webp",
    "property_primary_color": "#4e5147",
    "property_price_range": "799 - 1219",
    "property_price_min": "799",
    "property_price_max": "1219",
    "property_bedrooms_range": "1 - 2",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "2",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": " - 920",
    "property_short_description": "At Raintree Apts. in Wichita, Kansas, your ideal home awaits! Choose from stylish studios to spacious two-bedrooms, all featuring modern amenities. Enjoy the sun by our sparkling pool, unwind in our clubhouse, or take your furry friend to the dog park. Experience community living with planned activities and lush walking trails. Prefer to explore on your own time? Self-guided tours are available.",
    "property_type": "Apartments",
    "property_total_units": "344",
    "property_website_url": "https://www.caseusa.com/apartments/ks/wichita/raintree/",
    "property_company_name": "Case & Associates",
    "_slug": "raintree-apartments",
    "_stateSlug": "ks",
    "_citySlug": "wichita"
  },
  {
    "multihub_property_id": "6767906449165623",
    "multihub_company_id": "5767906449162419",
    "property_name": "Redbud Ranch",
    "property_slug": "redbud-ranch",
    "property_address": "2701 North 23rd St",
    "property_address_1": "2701 North 23rd St",
    "property_address_city": "Broken Arrow",
    "property_address_state": "OK",
    "property_address_zip": "74014",
    "property_address_latitude": "36.0789",
    "property_address_longitude": "-95.76097",
    "property_phone": "(539) 379-5663",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019fb44b-92d7-73ad-a57c-0797f86344ae.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-4f35-769f-aadc-9335630048e3.webp",
    "property_primary_color": "#000000",
    "property_price_range": "1214 - 2009",
    "property_price_min": "1214",
    "property_price_max": "2009",
    "property_bedrooms_range": "1 - 3",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "3",
    "property_bathrooms_range": "1 - 2.5",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2.5",
    "property_sqft_range": "789 - 1435",
    "property_short_description": "<p>At Redbud Ranch in Broken Arrow, Oklahoma, our vibrant community offers a variety of thoughtfully designed floor plans—one, two, and three bedrooms—catering to every lifestyle. Enjoy luxurious amenities, from our sparkling pool and fitness center to pet-friendly spaces. Your perfect home awaits—browse availability or schedule a tour today! Prefer to explore on your own time? Self-guided tours are available.</p>",
    "property_type": "Apartments",
    "property_total_units": "309",
    "property_website_url": "https://www.caseusa.com/apartments/ok/broken-arrow/redbud-ranch/",
    "property_company_name": "Case & Associates",
    "_slug": "redbud-ranch",
    "_stateSlug": "ok",
    "_citySlug": "broken-arrow"
  },
  {
    "multihub_property_id": "6767906449165624",
    "multihub_company_id": "5767906449162419",
    "property_name": "Shadow Ridge Apts.",
    "property_slug": "shadow-ridge-apts.",
    "property_address": "9375 Viscount Blvd.",
    "property_address_1": "9375 Viscount Blvd.",
    "property_address_city": "El Paso",
    "property_address_state": "TX",
    "property_address_zip": "79925",
    "property_address_latitude": "31.7701",
    "property_address_longitude": "-106.3629",
    "property_phone": "(915) 615-1984",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019cfb47-712b-700a-91e8-9ce9ee86730f.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019cfb46-cf87-704d-9895-15b861364cdb.webp",
    "property_primary_color": "#4f4842",
    "property_price_range": "1115 - 1475",
    "property_price_min": "1115",
    "property_price_max": "1475",
    "property_bedrooms_range": "1 - 2",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "2",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "457 - 958",
    "property_short_description": "At Shadow Ridge Apts. in El Paso, Texas, enjoy a range of stylish floor plans from cozy studios to spacious three-bedrooms. Dive into luxury amenities like a sparkling pool, modern fitness center, and pet-friendly spaces. Embrace comfort, convenience, and community—secure your ideal home today and schedule a tour! Prefer to explore on your own time? Self-guided tours are available.",
    "property_type": "Apartments",
    "property_total_units": "352",
    "property_website_url": "https://www.caseusa.com/apartments/tx/el-paso/shadow-ridge-apts/",
    "property_company_name": "Case & Associates",
    "_slug": "shadow-ridge-apts",
    "_stateSlug": "tx",
    "_citySlug": "el-paso"
  },
  {
    "multihub_property_id": "6767906449165625",
    "multihub_company_id": "5767906449162419",
    "property_name": "Sheridan Pond",
    "property_slug": "sheridan-pond",
    "property_address": "8130 South Lakewood Place",
    "property_address_1": "8130 South Lakewood Place",
    "property_address_city": "Tulsa",
    "property_address_state": "OK",
    "property_address_zip": "74137",
    "property_address_latitude": "36.0448",
    "property_address_longitude": "-95.906",
    "property_phone": "(539) 234-6696",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019cfb46-fb44-7613-871b-7f058d55ba3c.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019cfb46-e70a-771e-97ee-35328ad1fd33.webp",
    "property_primary_color": "#650004",
    "property_price_range": "909 - 1704",
    "property_price_min": "909",
    "property_price_max": "1704",
    "property_bedrooms_range": "1 - 3",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "3",
    "property_bathrooms_range": "1 - 2.5",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2.5",
    "property_sqft_range": "547 - 1488",
    "property_short_description": "Nestled in the heart of Tulsa, Sheridan Pond offers stylish one, two, and three-bedroom apartments that redefine comfort. With amenities like a sparkling pool, modern fitness center, and serene pond views, your perfect sanctuary awaits. Walk into luxury—schedule a tour or check availability today! Prefer to explore on your own time? Self-guided tours are available.",
    "property_type": "Apartments",
    "property_total_units": "240",
    "property_website_url": "https://www.caseusa.com/apartments/ok/tulsa/sheridan-pond/",
    "property_company_name": "Case & Associates",
    "_slug": "sheridan-pond",
    "_stateSlug": "ok",
    "_citySlug": "tulsa"
  },
  {
    "multihub_property_id": "6767906449165626",
    "multihub_company_id": "5767906449162419",
    "property_name": "Stonehorse Crossing",
    "property_slug": "stonehorse-crossing",
    "property_address": "14320 Mezzaluna Ave.",
    "property_address_1": "14320 Mezzaluna Ave.",
    "property_address_city": "Oklahoma City",
    "property_address_state": "OK",
    "property_address_zip": "73134",
    "property_address_latitude": "35.6175",
    "property_address_longitude": "-97.5598",
    "property_phone": "(405) 993-5057",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019cfb48-82db-76d9-b03d-338231fdc4e1.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165626/019cfb47-6d6b-74fb-b8aa-a92e079e3163.webp",
    "property_primary_color": "#00aebc",
    "property_price_range": "1169 - 1629",
    "property_price_min": "1169",
    "property_price_max": "1629",
    "property_bedrooms_range": "1 - 2",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "2",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "789 - 1267",
    "property_short_description": "<p>At Stonehorse Crossing in Oklahoma City, your ideal home awaits. Choose from spacious one- and two-bedroom floor plans, each boasting modern upgrades like granite countertops and stainless steel appliances. Enjoy resort-style amenities including a sparkling pool, fitness center, and dog park. Schedule a tour today and experience the vibrant lifestyle! Prefer to explore on your own time? Self-guided tours are available.</p>",
    "property_type": "Apartments",
    "property_total_units": "300",
    "property_website_url": "https://www.caseusa.com/apartments/ok/oklahoma-city/stonehorse-crossing/",
    "property_company_name": "Case & Associates",
    "_slug": "stonehorse-crossing",
    "_stateSlug": "ok",
    "_citySlug": "oklahoma-city"
  },
  {
    "multihub_property_id": "6767906449165627",
    "multihub_company_id": "5767906449162419",
    "property_name": "Sugarberry Apartments",
    "property_slug": "sugarberry-apartments",
    "property_address": "10902 East 61st Street",
    "property_address_1": "10902 East 61st Street",
    "property_address_city": "Tulsa",
    "property_address_state": "OK",
    "property_address_zip": "74133",
    "property_address_latitude": "36.0734",
    "property_address_longitude": "-95.8542",
    "property_phone": "(539) 424-0515",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019cfb47-8578-7114-a2f3-bc0b813bc25d.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019cfb47-8538-76fc-8119-4e937eab78f5.webp",
    "property_primary_color": "#182b17",
    "property_price_range": "1009 - 1579",
    "property_price_min": "1009",
    "property_price_max": "1579",
    "property_bedrooms_range": "1 - 3",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "3",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "725 - 1200",
    "property_short_description": "At Sugarberry Apartments in Tulsa, your ideal living space awaits. Choose from one, two, or three-bedroom floor plans, all featuring modern amenities like a refreshing pool, fitness center, and pet-friendly play areas. With a welcoming clubhouse and scenic trails, your perfect home is just a tour away! Prefer to explore on your own time? Self-guided tours are available.",
    "property_type": "Apartments",
    "property_total_units": "304",
    "property_website_url": "https://www.caseusa.com/apartments/ok/tulsa/sugarberry/",
    "property_company_name": "Case & Associates",
    "_slug": "sugarberry-apartments",
    "_stateSlug": "ok",
    "_citySlug": "tulsa"
  },
  {
    "multihub_property_id": "6767906449165628",
    "multihub_company_id": "5767906449162419",
    "property_name": "Summerfield Place Apts.",
    "property_slug": "summerfield-place-apts.",
    "property_address": "11777 North Meridian",
    "property_address_1": "11777 North Meridian",
    "property_address_city": "Oklahoma City",
    "property_address_state": "OK",
    "property_address_zip": "73162",
    "property_address_latitude": "35.5886",
    "property_address_longitude": "-97.6043",
    "property_phone": "(405) 407-3282",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165628/019cfb49-4e63-72ba-b9a8-7c4b78a5d135.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165628/019cfb48-4b67-7367-9a7a-20ca246755ed.webp",
    "property_primary_color": "#324d58",
    "property_price_range": "859 - 1139",
    "property_price_min": "859",
    "property_price_max": "1139",
    "property_bedrooms_range": "1 - 2",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "2",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "450 - 950",
    "property_short_description": "Welcome to Summerfield Place Apts. in vibrant Oklahoma City! Choose from stylish one and two-bedroom floor plans featuring modern amenities like high-speed internet, a refreshing pool, and a fitness center. Embrace outdoor living with our picnic area and walking trails. Your ideal lifestyle awaits—schedule a tour today!",
    "property_type": "Apartments",
    "property_total_units": "224",
    "property_website_url": "https://www.caseusa.com/apartments/ok/oklahoma-city/summerfield-place/",
    "property_company_name": "Case & Associates",
    "_slug": "summerfield-place-apts",
    "_stateSlug": "ok",
    "_citySlug": "oklahoma-city"
  },
  {
    "multihub_property_id": "6767906449165629",
    "multihub_company_id": "5767906449162419",
    "property_name": "Sunchase Apartments",
    "property_slug": "sunchase-apartments",
    "property_address": "8101 East 93rd Street",
    "property_address_1": "8101 East 93rd Street",
    "property_address_city": "Tulsa",
    "property_address_state": "OK",
    "property_address_zip": "74133",
    "property_address_latitude": "36.0286",
    "property_address_longitude": "-95.8838",
    "property_phone": "(539) 218-0640",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019fb44b-c5c8-74cc-b2e5-70da7b7aa7e6.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019cfb48-1360-7063-a695-1893602d804c.webp",
    "property_primary_color": "#000000",
    "property_price_range": "784 - 1074",
    "property_price_min": "784",
    "property_price_max": "1074",
    "property_bedrooms_range": "1 - 2",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "2",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "500 - 900",
    "property_short_description": "Welcome to Sunchase Apartments in Tulsa, Oklahoma, where comfort meets convenience. Choose from spacious one- and two-bedroom layouts, and enjoy fabulous amenities like a sparkling pool, fitness center, and serene walking trails. The perfect blend of relaxation and recreation awaits—find your new home today by browsing availability or scheduling a tour! Prefer to explore on your own time? Self-guided tours are available.",
    "property_type": "Apartments",
    "property_total_units": "416",
    "property_website_url": "https://www.caseusa.com/apartments/ok/tulsa/sunchase/",
    "property_company_name": "Case & Associates",
    "_slug": "sunchase-apartments",
    "_stateSlug": "ok",
    "_citySlug": "tulsa"
  },
  {
    "multihub_property_id": "6767906449165630",
    "multihub_company_id": "5767906449162419",
    "property_name": "Sunchase Ridgeland Apts.",
    "property_slug": "sunchase-ridgeland-apts.",
    "property_address": "875 William Blvd",
    "property_address_1": "875 William Blvd",
    "property_address_city": "Ridgeland",
    "property_address_state": "MS",
    "property_address_zip": "39157",
    "property_address_latitude": "32.4059",
    "property_address_longitude": "-90.1026",
    "property_phone": "(601) 908-2633",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019cfb48-3e77-776b-a3a7-7c013102a522.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165630/019cfb48-5b74-75e2-9dfa-0dfacd18a365.webp",
    "property_primary_color": "#5d3932",
    "property_price_range": "1299 - 1329",
    "property_price_min": "1299",
    "property_price_max": "1329",
    "property_bedrooms_range": "2",
    "property_bedrooms_min": "2",
    "property_bedrooms_max": "2",
    "property_bathrooms_range": "2 - 2",
    "property_bathrooms_min": "2",
    "property_bathrooms_max": "2",
    "property_sqft_range": "925 - 925",
    "property_short_description": "Welcome to Sunchase Ridgeland Apts., where comfort and convenience marry in beautiful harmony. Choose from spacious one and two-bedroom floor plans, and indulge in premium amenities like a sparkling pool, well-equipped fitness center, and inviting clubhouse. Your ideal lifestyle awaits—explore our availability or schedule a tour today! Prefer to explore on your own time? Self-guided tours are available.",
    "property_type": "Apartments",
    "property_total_units": "413",
    "property_website_url": "https://www.caseusa.com/apartments/ms/ridgeland/sunchase-ridgeland/",
    "property_company_name": "Case & Associates",
    "_slug": "sunchase-ridgeland-apts",
    "_stateSlug": "ms",
    "_citySlug": "ridgeland"
  },
  {
    "multihub_property_id": "6767906449165631",
    "multihub_company_id": "5767906449162419",
    "property_name": "Tammaron Village Apartments",
    "property_slug": "tammaron-village-apartments",
    "property_address": "11100 Roxboro",
    "property_address_1": "11100 Roxboro",
    "property_address_city": "Oklahoma City",
    "property_address_state": "OK",
    "property_address_zip": "73162",
    "property_address_latitude": "35.581",
    "property_address_longitude": "-97.65",
    "property_phone": "(405) 358-2175",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019cfb49-c386-7105-9e5c-0d9179a998af.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019cfb48-b3a1-738a-8726-59e90ac5578a.webp",
    "property_primary_color": "#434442",
    "property_price_range": "689 - 989",
    "property_price_min": "689",
    "property_price_max": "989",
    "property_bedrooms_range": "1 - 2",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "2",
    "property_bathrooms_range": "1 - 1",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "1",
    "property_sqft_range": "500 - 850",
    "property_short_description": "Welcome to Tammaron Village Apartments in vibrant Oklahoma City, where contemporary living meets comfort. Choose from stylish studio, one, or two-bedroom floor plans. Enjoy resort-style amenities, including two sparkling pools, an upscale clubhouse, and a dog park. Embrace effortless living with flexible payment options and 24-hour maintenance. Secure your new home today! Prefer to explore on your own time? Self-guided tours are available.",
    "property_type": "Apartments",
    "property_total_units": "400",
    "property_website_url": "https://www.caseusa.com/apartments/ok/oklahoma-city/tammaron-village/",
    "property_company_name": "Case & Associates",
    "_slug": "tammaron-village-apartments",
    "_stateSlug": "ok",
    "_citySlug": "oklahoma-city"
  },
  {
    "multihub_property_id": "6767906449165632",
    "multihub_company_id": "5767906449162419",
    "property_name": "The Adirondack",
    "property_slug": "the-adirondack",
    "property_address": "4580 S. Bass Pro Dr.",
    "property_address_1": "4580 S. Bass Pro Dr.",
    "property_address_city": "Independence",
    "property_address_state": "MO",
    "property_address_zip": "64055",
    "property_address_latitude": "39.0397",
    "property_address_longitude": "-94.3723",
    "property_phone": "(816) 323-8521",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019fb44b-90d7-71aa-93b3-be46a1bfb4e6.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019cfb49-2a10-7459-86b4-962a5c3bec85.webp",
    "property_primary_color": "#222222",
    "property_price_range": "1339 - 1659",
    "property_price_min": "1339",
    "property_price_max": "1659",
    "property_bedrooms_range": "1 - 2",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "2",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "789 - 1125",
    "property_short_description": "Experience modern living at The Adirondack in Independence, Missouri, where spacious one and two-bedroom floor plans meet luxurious amenities. Enjoy a refreshing dip in the pool, workout in the fitness center, or relax in the clubhouse. With pet-friendly features and stylish interiors, your perfect home awaits. Schedule a tour today! Prefer to explore on your own time? Self-guided tours are available.",
    "property_type": "Apartments",
    "property_total_units": "275",
    "property_website_url": "https://rentnow.adirondackapartmentsindependence.com/",
    "property_company_name": "Case & Associates",
    "_slug": "the-adirondack",
    "_stateSlug": "mo",
    "_citySlug": "independence"
  },
  {
    "multihub_property_id": "6767906449165633",
    "multihub_company_id": "5767906449162419",
    "property_name": "The Courtyards",
    "property_slug": "the-courtyards",
    "property_address": "6748 E. 91st Street",
    "property_address_1": "6748 E. 91st Street",
    "property_address_city": "Tulsa",
    "property_address_state": "OK",
    "property_address_zip": "74133",
    "property_address_latitude": "36.0304",
    "property_address_longitude": "-95.901",
    "property_phone": "(539) 265-2726",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019cfb4a-a863-768d-94ea-6f3a63b32d71.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019cfb49-a807-7209-9b25-66d6350ad8fa.webp",
    "property_primary_color": "#283849",
    "property_price_range": "984 - 1404",
    "property_price_min": "984",
    "property_price_max": "1404",
    "property_bedrooms_range": "1 - 2",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "2",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "550 - 1029",
    "property_short_description": "<p>At The Courtyards in Tulsa, your ideal home awaits with spacious one and two-bedroom layouts. Enjoy resort-style amenities—swim in the refreshing pool, stay fit in the gym, or unwind at the inviting clubhouse. With picturesque walking trails and each unit designed for comfort, the perfect lifestyle is just a visit away! Prefer to explore on your own time? Self-guided tours are available.</p>",
    "property_type": "Apartments",
    "property_total_units": "272",
    "property_website_url": "https://www.caseusa.com/apartments/ok/tulsa/the-courtyards/",
    "property_company_name": "Case & Associates",
    "_slug": "the-courtyards",
    "_stateSlug": "ok",
    "_citySlug": "tulsa"
  },
  {
    "multihub_property_id": "6767906449165634",
    "multihub_company_id": "5767906449162419",
    "property_name": "The Greens of Bedford",
    "property_slug": "the-greens-of-bedford",
    "property_address": "6508-6513 S 106th East Pl",
    "property_address_1": "6508 South 106th East Place",
    "property_address_city": "Tulsa",
    "property_address_state": "OK",
    "property_address_zip": "74133",
    "property_address_latitude": "36.0694",
    "property_address_longitude": "-95.8576",
    "property_phone": "(539) 995-5864",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019cfb4a-92a4-72f3-9753-9694c7cd3e1f.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/019cfb49-9f19-7647-9092-a7aa72a2ecb4.webp",
    "property_primary_color": "#324d58",
    "property_price_range": "989 - 1129",
    "property_price_min": "989",
    "property_price_max": "1129",
    "property_bedrooms_range": "1 - 2",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "2",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "700 - 1100",
    "property_short_description": "<p>At The Greens of Bedford in Tulsa, Oklahoma, luxury living meets comfort in our thoughtfully designed one, two, and three-bedroom apartments. Enjoy an array of amenities, including a refreshing pool, state-of-the-art fitness center, and serene walking trails. Your perfect home awaits—browse availability or schedule your tour today! Prefer to explore on your own time? Self-guided tours are available.</p>",
    "property_type": "Apartments",
    "property_total_units": "384",
    "property_website_url": "https://www.caseusa.com/apartments/ok/tulsa/the-greens-of-bedford/",
    "property_company_name": "Case & Associates",
    "_slug": "the-greens-of-bedford",
    "_stateSlug": "ok",
    "_citySlug": "tulsa"
  },
  {
    "multihub_property_id": "6767906449165635",
    "multihub_company_id": "5767906449162419",
    "property_name": "The Reserve at Elm",
    "property_slug": "the-reserve-at-elm",
    "property_address": "701 West 101st Pl. South",
    "property_address_1": "701 West 101st Pl. South",
    "property_address_city": "Jenks",
    "property_address_state": "OK",
    "property_address_zip": "74037",
    "property_address_latitude": "36.0192",
    "property_address_longitude": "-95.9798",
    "property_phone": "(918) 246-6510",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019cfb49-8ebd-742a-a896-552a382109da.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019cfb49-e29d-7189-adfd-bf7995830945.webp",
    "property_primary_color": "#b9975b",
    "property_price_range": "1199 - 1704",
    "property_price_min": "1199",
    "property_price_max": "1704",
    "property_bedrooms_range": "1 - 2",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "2",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "789 - 1176",
    "property_short_description": "<p>At The Reserve at Elm in Jenks, Oklahoma, each thoughtfully designed one and two-bedroom floor plan offers modern living with luxurious amenities. Enjoy resort-style features like a sparkling pool, fitness center, and dog park, all within a gated community. Your ideal apartment awaits—schedule a tour or browse our availability today! Prefer to explore on your own time? Self-guided tours are available.</p>",
    "property_type": "Apartments",
    "property_total_units": "260",
    "property_website_url": "https://www.caseusa.com/apartments/ok/jenks/reserve-at-elm/",
    "property_company_name": "Case & Associates",
    "_slug": "the-reserve-at-elm",
    "_stateSlug": "ok",
    "_citySlug": "jenks"
  },
  {
    "multihub_property_id": "6767906449165636",
    "multihub_company_id": "5767906449162419",
    "property_name": "The Ridge @ 66",
    "property_slug": "the-ridge-@-66",
    "property_address": "4300 Caravel Dr.",
    "property_address_1": "4300 Caravel Dr.",
    "property_address_city": "Yukon",
    "property_address_state": "OK",
    "property_address_zip": "73099",
    "property_address_latitude": "35.5136",
    "property_address_longitude": "-97.7019",
    "property_phone": "(405) 497-8702",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019fb44b-b61c-7551-9037-12526761bd0a.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019cfb4a-54c4-720b-a7de-ea34beac3e88.webp",
    "property_primary_color": "#4c5646",
    "property_price_range": "1209 - 1779",
    "property_price_min": "1209",
    "property_price_max": "1779",
    "property_bedrooms_range": "1 - 3",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "3",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "789 - 1473",
    "property_short_description": "Welcome to The Ridge @ 66 in Yukon, Oklahoma, where stylish living meets unparalleled amenities. Whether you choose a cozy one-bedroom or a spacious three-bedroom, enjoy resort-style perks like a sparkling pool, inviting clubhouse, and a dedicated pet play area. Your perfect home awaits—eager to explore? Schedule a tour today! Prefer to explore on your own time? Self-guided tours are available.",
    "property_type": "Apartments",
    "property_total_units": "339",
    "property_website_url": "https://www.caseusa.com/apartments/ok/yukon/ridge-at-66/",
    "property_company_name": "Case & Associates",
    "_slug": "the-ridge-66",
    "_stateSlug": "ok",
    "_citySlug": "yukon"
  },
  {
    "multihub_property_id": "6767906449165637",
    "multihub_company_id": "5767906449162419",
    "property_name": "Trace Apts.",
    "property_slug": "trace-apts.",
    "property_address": "340 Arbor Drive",
    "property_address_1": "340 Arbor Drive",
    "property_address_city": "Ridgeland",
    "property_address_state": "MS",
    "property_address_zip": "39157",
    "property_address_latitude": "32.4095",
    "property_address_longitude": "-90.1275",
    "property_phone": "(601) 751-4575",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019cfb4b-c3ee-74d9-add6-0d0cb970c51f.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165637/019cfb4a-e4bb-754b-bd15-f4074836b303.webp",
    "property_primary_color": "#13545c",
    "property_price_range": "1024 - 1284",
    "property_price_min": "1024",
    "property_price_max": "1284",
    "property_bedrooms_range": "1 - 1",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "1",
    "property_bathrooms_range": "1 - 1",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "1",
    "property_sqft_range": "600 - 850",
    "property_short_description": "At Trace Apts. in Ridgeland, Mississippi, vibrant living awaits. Choose from spacious one or two-bedroom floor plans and indulge in a range of amenities, from refreshing pools and a fully-equipped fitness center to tennis courts and serene picnic areas. Your perfect home is just a tour away—see what’s available today! Prefer to explore on your own time? Self-guided tours are available.",
    "property_type": "Apartments",
    "property_website_url": "https://www.caseusa.com/apartments/ms/ridgeland/trace-of-ridgeland/",
    "property_company_name": "Case & Associates",
    "_slug": "trace-apts",
    "_stateSlug": "ms",
    "_citySlug": "ridgeland"
  },
  {
    "multihub_property_id": "6767906449165638",
    "multihub_company_id": "5767906449162419",
    "property_name": "Trails at Aspen Creek",
    "property_slug": "trails-at-aspen-creek",
    "property_address": "2602 W. Tucson St.",
    "property_address_1": "2602 W. Tucson St.",
    "property_address_city": "Broken  Arrow",
    "property_address_state": "OK",
    "property_address_zip": "74011",
    "property_address_latitude": "35.989",
    "property_address_longitude": "-95.8214",
    "property_phone": "5392164362",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019cfb4c-bec2-73d6-a335-03506a514ad0.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019cfb4b-5386-741a-9ac9-e94765f46fe2.webp",
    "property_primary_color": "#daba6b",
    "property_price_range": "1269 - 2254",
    "property_price_min": "1269",
    "property_price_max": "2254",
    "property_bedrooms_range": "1 - 3",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "3",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "789 - 1435",
    "property_short_description": "<p>Welcome to Trails at Aspen Creek in Broken Arrow, where modern comfort meets nature's tranquility. Choose from spacious one, two, or three-bedroom floor plans, and enjoy premium amenities like a serene pool, fitness center, and dog park. Your ideal home, complete with inviting spaces, awaits—let's connect! Prefer to explore on your own time? Self-guided tours are available.</p>",
    "property_type": "Apartments",
    "property_total_units": "365",
    "property_website_url": "https://www.caseusa.com/apartments/ok/broken-arrow/trails-at-aspen-creek/",
    "property_company_name": "Case & Associates",
    "_slug": "trails-at-aspen-creek",
    "_stateSlug": "ok",
    "_citySlug": "broken-arrow"
  },
  {
    "multihub_property_id": "6767906449165639",
    "multihub_company_id": "5767906449162419",
    "property_name": "Tuscany Ranch Apartments",
    "property_slug": "tuscany-ranch-apartments",
    "property_address": "2100 South New Road",
    "property_address_1": "2100 S New Rd",
    "property_address_city": "Waco",
    "property_address_state": "Texas",
    "property_address_zip": "76711",
    "property_address_latitude": "31.50859",
    "property_address_longitude": "-97.15239",
    "property_phone": "(254) 328-1637",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019cfb4c-9a84-7204-b5b6-01b22c8de197.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165639/019cfb4c-b2c9-72be-804c-2f3bab4f8a57.webp",
    "property_primary_color": "#4e5147",
    "property_price_range": "1559 - 1829",
    "property_price_min": "1559",
    "property_price_max": "1829",
    "property_bedrooms_range": "2 - 2",
    "property_bedrooms_min": "2",
    "property_bedrooms_max": "2",
    "property_bathrooms_range": "2 - 2",
    "property_bathrooms_min": "2",
    "property_bathrooms_max": "2",
    "property_sqft_range": "1050 - 1176",
    "property_short_description": "<p>At Tuscany Ranch Apartments in Waco, Texas, enjoy spacious one- and two-bedroom floor plans, complete with modern amenities like a sparkling pool, fitness center, and pet-friendly spaces. With thoughtful touches such as a concierge service and walking trails, your perfect retreat awaits. Make Tuscany Ranch your home today! Prefer to explore on your own time? Self-guided tours are available.</p>",
    "property_type": "Apartments",
    "property_total_units": "260",
    "property_website_url": "https://www.caseusa.com/apartments/tx/waco/tuscany-ranch/",
    "property_company_name": "Case & Associates",
    "_slug": "tuscany-ranch-apartments",
    "_stateSlug": "tx",
    "_citySlug": "waco"
  },
  {
    "multihub_property_id": "6767906449165640",
    "multihub_company_id": "5767906449162419",
    "property_name": "Villas at Aspen Park",
    "property_slug": "villas-at-aspen-park",
    "property_address": "2001 W Princeton Circle",
    "property_address_1": "2001 W Princeton Circle",
    "property_address_city": "Broken Arrow",
    "property_address_state": "OK",
    "property_address_zip": "74012",
    "property_address_latitude": "36.0668",
    "property_address_longitude": "-95.8139",
    "property_phone": "(539) 245-4119",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019fb44b-b6f5-7709-9b70-eac98f67099f.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019cfb4b-640a-759d-88d3-e2b047e77693.webp",
    "property_primary_color": "#8bc53f",
    "property_price_range": "1109 - 1319",
    "property_price_min": "1109",
    "property_price_max": "1319",
    "property_bedrooms_range": "1 - 2",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "2",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "789 - 1050",
    "property_short_description": "Welcome to Villas at Aspen Park in Broken Arrow, where comfort meets convenience. Our one and two-bedroom apartments feature modern amenities, including a refreshing pool, a state-of-the-art fitness center, and a welcoming clubhouse. Enjoy serene picnics by the pond or take your furry friend to the dog park. Your perfect home awaits! Prefer to explore on your own time? Self-guided tours are available.",
    "property_type": "Apartments",
    "property_total_units": "270",
    "property_website_url": "https://www.caseusa.com/apartments/ok/broken-arrow/villas-at-aspen-park/",
    "property_company_name": "Case & Associates",
    "_slug": "villas-at-aspen-park",
    "_stateSlug": "ok",
    "_citySlug": "broken-arrow"
  },
  {
    "multihub_property_id": "6767906449165641",
    "multihub_company_id": "5767906449162419",
    "property_name": "Villas at Stonebridge",
    "property_slug": "villas-at-stonebridge",
    "property_address": "157 Stonebridge Blvd.",
    "property_address_1": "157 Stonebridge Blvd.",
    "property_address_city": "Edmond",
    "property_address_state": "OK",
    "property_address_zip": "73013",
    "property_address_latitude": "35.6202",
    "property_address_longitude": "-97.4826",
    "property_phone": "(405) 451-1465",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019cfb4c-65e8-72dc-a48d-2d2504000832.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019cfb4c-5c5e-73cd-a32f-096698630609.webp",
    "property_primary_color": "#845950",
    "property_price_range": "1119 - 1584",
    "property_price_min": "1119",
    "property_price_max": "1584",
    "property_bedrooms_range": "1 - 3",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "3",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "789 - 1178",
    "property_short_description": "Live life elevated at Villas at Stonebridge in Edmond, Oklahoma, where modern living meets comfort. Choose from spacious one to three-bedroom floor plans featuring vaulted ceilings and walk-in closets. Relax by the pool, stay fit in our gym, or unwind in the clubhouse. Your perfect home awaits—schedule a tour today! Prefer to explore on your own time? Self-guided tours are available.",
    "property_type": "Apartments",
    "property_total_units": "484",
    "property_website_url": "https://www.caseusa.com/apartments/ok/edmond/villas-at-stonebridge/",
    "property_company_name": "Case & Associates",
    "_slug": "villas-at-stonebridge",
    "_stateSlug": "ok",
    "_citySlug": "edmond"
  },
  {
    "multihub_property_id": "6767906449165642",
    "multihub_company_id": "5767906449162419",
    "property_name": "Warrington Apartments",
    "property_slug": "warrington-apartments",
    "property_address": "12700 North MacArthur",
    "property_address_1": "12700 North MacArthur",
    "property_address_city": "Oklahoma City",
    "property_address_state": "OK",
    "property_address_zip": "73142",
    "property_address_latitude": "35.6",
    "property_address_longitude": "-97.6192",
    "property_phone": "(405) 374-5108",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019cfb4d-430f-71b1-a431-af46ca883872.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165642/019cfb4c-4510-72ba-9132-65724c7993af.webp",
    "property_primary_color": "#4f4942",
    "property_price_range": "939 - 1309",
    "property_price_min": "939",
    "property_price_max": "1309",
    "property_bedrooms_range": "1 - 2",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "2",
    "property_bathrooms_range": "1 - 2.5",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2.5",
    "property_sqft_range": "624 - 1065",
    "property_short_description": "At Warrington Apartments in Oklahoma City, comfort and convenience collide. Choose from spacious one and two-bedroom floor plans, and enjoy amenities like a refreshing pool, modern fitness center, and serene sundeck. Experience a vibrant community with a picnic area and on-site maintenance. Make Warrington your new home today—schedule a tour! Prefer to explore on your own time? Self-guided tours are available.",
    "property_type": "Apartments",
    "property_total_units": "204",
    "property_website_url": "https://www.caseusa.com/apartments/ok/oklahoma-city/warrington/",
    "property_company_name": "Case & Associates",
    "_slug": "warrington-apartments",
    "_stateSlug": "ok",
    "_citySlug": "oklahoma-city"
  },
  {
    "multihub_property_id": "6767906449165643",
    "multihub_company_id": "5767906449162419",
    "property_name": "Waters Edge Apartments",
    "property_slug": "waters-edge-apartments",
    "property_address": "4317 SW 22nd St.",
    "property_address_1": "4317 SW 22nd St.",
    "property_address_city": "Oklahoma City",
    "property_address_state": "OK",
    "property_address_zip": "73108",
    "property_address_latitude": "35.4444",
    "property_address_longitude": "-97.5948",
    "property_phone": "(405) 267-7241",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019fb44b-be7f-74cd-bb11-c07d324cf8c1.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019cfb4c-f31f-71c8-af84-c940e15c74f6.webp",
    "property_primary_color": "#000000",
    "property_price_range": "779 - 1064",
    "property_price_min": "779",
    "property_price_max": "1064",
    "property_bedrooms_range": "1 - 2",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "2",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "396 - 896",
    "property_short_description": "At Waters Edge Apartments in Oklahoma City, elevate your lifestyle with meticulously designed studio, one, and two-bedroom layouts. Enjoy amenities like a sparkling pool, fitness center, and pet-friendly play area, all nestled by serene lake access. Picture your life here—schedule a tour and find your perfect home today! Prefer to explore on your own time? Self-guided tours are available.",
    "property_type": "Apartments",
    "property_total_units": "368",
    "property_website_url": "https://www.caseusa.com/apartments/ok/oklahoma-city/waters-edge/",
    "property_company_name": "Case & Associates",
    "_slug": "waters-edge-apartments",
    "_stateSlug": "ok",
    "_citySlug": "oklahoma-city"
  },
  {
    "multihub_property_id": "6767906449165644",
    "multihub_company_id": "5767906449162419",
    "property_name": "Winchester Apartments",
    "property_slug": "winchester-apartments",
    "property_address": "5509 S.W. 9th Avenue",
    "property_address_1": "5509 S.W. 9th Avenue",
    "property_address_city": "Amarillo",
    "property_address_state": "TX",
    "property_address_zip": "79106",
    "property_address_latitude": "35.2051",
    "property_address_longitude": "-101.9009",
    "property_phone": "(806) 835-5080",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4c-d6d8-7508-9dd1-08b406da0d26.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4d-2c95-7568-95df-c01524328a7f.webp",
    "property_primary_color": "#000000",
    "property_price_range": "1254 - 1549",
    "property_price_min": "1254",
    "property_price_max": "1549",
    "property_bedrooms_range": "1 - 2",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "2",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "725 - 961",
    "property_short_description": "At Winchester Apartments in Amarillo, Texas, a world of comfort awaits. Choose from spacious one, two, or three-bedroom floor plans designed for modern living. Enjoy amenities like a sparkling pool, fitness center, and inviting clubhouse. Embrace the perfect blend of style and convenience—your new home is just a click away! Prefer to explore on your own time? Self-guided tours are available.",
    "property_type": "Apartments",
    "property_total_units": "256",
    "property_website_url": "https://www.caseusa.com/apartments/tx/amarillo/winchester/",
    "property_company_name": "Case & Associates",
    "_slug": "winchester-apartments",
    "_stateSlug": "tx",
    "_citySlug": "amarillo"
  },
  {
    "multihub_property_id": "6767906449165645",
    "multihub_company_id": "5767906449162419",
    "property_name": "Windsail Apartments",
    "property_slug": "windsail-apartments",
    "property_address": "9808 East 73rd Street South",
    "property_address_1": "9808 East 73rd Street South",
    "property_address_city": "Tulsa",
    "property_address_state": "OK",
    "property_address_zip": "74133",
    "property_address_latitude": "36.0581",
    "property_address_longitude": "-95.8669",
    "property_phone": "(539) 233-0803",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019fb44c-69ef-7259-ad46-f818ac7ec9bb.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019cfb4d-658f-72d9-b0c3-f68080938959.webp",
    "property_primary_color": "#3d3d3f",
    "property_price_range": "539 - 1364",
    "property_price_min": "539",
    "property_price_max": "1364",
    "property_bedrooms_range": "1 - 2",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "2",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "600 - 1000",
    "property_short_description": "At Windsail Apts. in Tulsa, your ideal living space awaits. Choose from stylish one and two-bedroom floor plans, all boasting amenities like a refreshing pool, a state-of-the-art fitness center, and spacious walk-in closets. Enjoy outdoor gatherings at our picnic area or relax in the cozy clubhouse. Your new home is calling! Prefer to explore on your own time? Self-guided tours are available.",
    "property_type": "Apartments",
    "property_total_units": "273",
    "property_website_url": "https://www.caseusa.com/apartments/ok/tulsa/windsail/",
    "property_company_name": "Case & Associates",
    "_slug": "windsail-apartments",
    "_stateSlug": "ok",
    "_citySlug": "tulsa"
  },
  {
    "multihub_property_id": "6767906449166542",
    "multihub_company_id": "5767906449162419",
    "property_name": "152 Northland",
    "property_slug": "152-northland",
    "property_address": "8800 North Ames Avenue",
    "property_address_1": "8800 N. Ames Drive",
    "property_address_city": "Kansas City",
    "property_address_state": "MO",
    "property_address_zip": "64154",
    "property_address_latitude": "39.253",
    "property_address_longitude": "-94.6014",
    "property_phone": "(816) 475-5649",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4d-775b-738d-ba95-0744848b90ad.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4e-6a9e-714d-868b-85648f0ded3f.webp",
    "property_primary_color": "#e5107b",
    "property_price_range": "1399 - 1779",
    "property_price_min": "1399",
    "property_price_max": "1779",
    "property_bedrooms_range": "1 - 2",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "2",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "789 - 1108",
    "property_short_description": "<p>At 152 Northland in Kansas City, MO, contemporary living meets comfort. Choose from unique one and two-bedroom floor plans that feature spacious layouts, modern appliances, and private balconies. Enjoy top-notch amenities, including a sundeck, fitness center, and clubhouse. Your perfect oasis awaits—browse availability or schedule your tour today! Prefer to explore on your own time? Self-guided tours are available.</p>",
    "property_type": "Apartments",
    "property_total_units": "341",
    "property_website_url": "https://www.caseusa.com/apartments/mo/kansas-city/152-northland/",
    "property_company_name": "Case & Associates",
    "_slug": "152-northland",
    "_stateSlug": "mo",
    "_citySlug": "kansas-city"
  },
  {
    "multihub_property_id": "6767906449166543",
    "multihub_company_id": "5767906449162419",
    "property_name": "Aspen Park Apartments",
    "property_slug": "aspen-park-apartments",
    "property_address": "8405 West Central Avenue",
    "property_address_1": "8405 West Central Avenue",
    "property_address_city": "Wichita",
    "property_address_state": "KS",
    "property_address_zip": "67212",
    "property_address_latitude": "37.6936",
    "property_address_longitude": "-97.4407",
    "property_phone": "(316) 323-1550",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019cfb4d-fa13-74be-92ae-ea1e63737115.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019cfb4e-4135-760c-8541-4cb015ae577b.webp",
    "property_primary_color": "#295044",
    "property_price_range": "799 - 1099",
    "property_price_min": "799",
    "property_price_max": "1099",
    "property_bedrooms_range": "studio - 2",
    "property_bedrooms_min": "studio",
    "property_bedrooms_max": "2",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "500 - 900",
    "property_short_description": "<p>Welcome to Aspen Park in Wichita, KS, where modern living meets comfort. Choose from spacious studio, one, or two-bedroom apartments equipped with premium amenities like a refreshing pool, fitness center, and serene courtyards. Elevate your lifestyle—view our floor plans and schedule a tour to experience it all firsthand! Prefer to explore on your own time? Self-guided tours are available.</p>",
    "property_type": "Apartments",
    "property_total_units": "384",
    "property_website_url": "https://www.caseusa.com/apartments/ks/wichita/aspen-park/",
    "property_company_name": "Case & Associates",
    "_slug": "aspen-park-apartments",
    "_stateSlug": "ks",
    "_citySlug": "wichita"
  },
  {
    "multihub_property_id": "6767906449166545",
    "multihub_company_id": "5767906449162419",
    "property_name": "Huntington Park",
    "property_slug": "huntington-park",
    "property_address": "1313 N. Maize Ct",
    "property_address_1": "1313 N. Maize Ct",
    "property_address_city": "Wichita",
    "property_address_state": "KS",
    "property_address_zip": "67212",
    "property_address_latitude": "37.7052",
    "property_address_longitude": "-97.4646",
    "property_phone": "(316) 541-4816",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166545/019cfb4e-5b17-77fb-91ae-6a0be2f681c2.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166545/019cfb4e-8c8a-737c-b188-84615380b977.webp",
    "property_primary_color": "#3d3d3f",
    "property_price_range": "949 - 1334",
    "property_price_min": "949",
    "property_price_max": "1334",
    "property_bedrooms_range": "1 - 2",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "2",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": " - 981",
    "property_short_description": "<p>Welcome to Huntington Park in Wichita, KS, where comfort meets convenience. Choose from our inviting one and two-bedroom floor plans, featuring modern amenities like a fitness center, outdoor pool, and a cozy clubhouse. Relax in style with upgraded interiors, spacious closets, and your own patio or balcony. Prefer to explore on your own time? Self-guided tours are available.</p>",
    "property_type": "Apartments",
    "property_website_url": "https://www.caseusa.com/apartments/ks/wichita/huntington-park/",
    "property_company_name": "Case & Associates",
    "_slug": "huntington-park",
    "_stateSlug": "ks",
    "_citySlug": "wichita"
  },
  {
    "multihub_property_id": "6767906449166546",
    "multihub_company_id": "5767906449162419",
    "property_name": "Newport Wichita Apts.",
    "property_slug": "newport-wichita-apts.",
    "property_address": "770 North Silver Springs Blvd.",
    "property_address_1": "770 North Silver Springs Blvd.",
    "property_address_city": "Wichita",
    "property_address_state": "KS",
    "property_address_zip": "67212",
    "property_address_latitude": "37.6961",
    "property_address_longitude": "-97.4219",
    "property_phone": "(316) 661-6020",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166546/019cfb4e-8e28-745d-9e57-c325943688c8.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166546/019cfb4e-d829-73bf-b9c1-43fa1c44bd53.webp",
    "property_primary_color": "#000000",
    "property_price_range": "959 - 1239",
    "property_price_min": "959",
    "property_price_max": "1239",
    "property_bedrooms_range": "1 - 2",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "2",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "730 - 1038",
    "property_short_description": "At Newport Wichita, your ideal home awaits amidst serene walking trails by a picturesque 10-acre lake. Choose from spacious one- and two-bedroom floor plans featuring vaulted ceilings and modern amenities. Enjoy our vibrant clubhouse, outdoor pool, and 24-hour fitness center. Elevate your living experience—schedule a tour today! Prefer to explore on your own time? Self-guided tours are available.",
    "property_type": "Apartments",
    "property_website_url": "https://www.caseusa.com/apartments/ks/wichita/newport-wichita/",
    "property_company_name": "Case & Associates",
    "_slug": "newport-wichita-apts",
    "_stateSlug": "ks",
    "_citySlug": "wichita"
  },
  {
    "multihub_property_id": "6767906449166547",
    "multihub_company_id": "5767906449162419",
    "property_name": "Portofino",
    "property_slug": "portofino",
    "property_address": "12526 East Central Avenue",
    "property_address_1": "12526 East Central Avenue",
    "property_address_city": "Wichita",
    "property_address_state": "KS",
    "property_address_zip": "67206",
    "property_address_latitude": "37.6952",
    "property_address_longitude": "-97.1918",
    "property_phone": "(316) 323-1549",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019dbbe9-0dde-74e7-bca7-322c32315f08.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019cfb4f-1afe-706b-a897-d302f11c5707.webp",
    "property_primary_color": "#16618e",
    "property_price_range": "1159 - 1639",
    "property_price_min": "1159",
    "property_price_max": "1639",
    "property_bedrooms_range": "1 - 2",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "2",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "789 - 1176",
    "property_short_description": "At Portofino in Wichita, KS, enjoy the perfect blend of comfort and convenience. Our spacious one- and two-bedroom apartments feature modern kitchens, large walk-in closets, and private patios. Amenities like a resort-style pool, 24-hour fitness center, and bark park create a vibrant community. Find your new home today! Prefer to explore on your own time? Self-guided tours are available.",
    "property_type": "Apartments",
    "property_website_url": "https://www.caseusa.com/apartments/ks/wichita/portofino/",
    "property_company_name": "Case & Associates",
    "_slug": "portofino",
    "_stateSlug": "ks",
    "_citySlug": "wichita"
  },
  {
    "multihub_property_id": "6767906449166548",
    "multihub_company_id": "5767906449162419",
    "property_name": "Remington Wichita Apts.",
    "property_slug": "remington-wichita-apts.",
    "property_address": "7272 East 37th Street North",
    "property_address_1": "7272 East 37th Street North",
    "property_address_city": "Wichita",
    "property_address_state": "KS",
    "property_address_zip": "67226",
    "property_address_latitude": "37.7527",
    "property_address_longitude": "-97.2526",
    "property_phone": "(316) 800-9797",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfdaa-63d5-727b-b70c-27d4c59068ed.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166548/019cfb4f-0427-7367-9815-5230564ef8b4.webp",
    "property_price_range": "1024 - 1294",
    "property_price_min": "1024",
    "property_price_max": "1294",
    "property_bedrooms_range": "1 - 2",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "2",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "738 - 978",
    "property_short_description": "<p>At Remington Wichita, comfort and convenience unite in spacious one and two-bedroom apartments. Enjoy our pet-friendly amenities, including a stunning outdoor pool, BBQ picnic area, and 24-hour fitness center. With easy access to K-96 and I-35, your ideal home is just a click away. Schedule your tour today! Prefer to explore on your own time? Self-guided tours are available.</p>",
    "property_type": "Apartments",
    "property_website_url": "https://www.caseusa.com/apartments/ks/wichita/the-remington/",
    "property_company_name": "Case & Associates",
    "_slug": "remington-wichita-apts",
    "_stateSlug": "ks",
    "_citySlug": "wichita"
  },
  {
    "multihub_property_id": "6767906449166549",
    "multihub_company_id": "5767906449162419",
    "property_name": "Silver Springs Apts.",
    "property_slug": "silver-springs-apts.",
    "property_address": "999 North Silver Springs Blvd",
    "property_address_1": "999 North Silver Springs Blvd",
    "property_address_city": "Wichita",
    "property_address_state": "KS",
    "property_address_zip": "67212",
    "property_address_latitude": "37.6993",
    "property_address_longitude": "-97.4252",
    "property_phone": "(316) 251-9950",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-c1be-7752-99d2-da749c803da4.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166549/019cfb4f-8b00-70b3-8657-3dcac4252252.webp",
    "property_primary_color": "#5d3932",
    "property_price_range": "794 - 1064",
    "property_price_min": "794",
    "property_price_max": "1064",
    "property_bedrooms_range": "1 - 2",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "2",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "500 - 950",
    "property_short_description": "<p>Welcome to Silver Springs in Wichita, KS, where modern living meets comfort. Choose from spacious studio, one-bedroom, or two-bedroom floor plans, each designed for your lifestyle. Enjoy amenities like a tropical pool, clubhouse, and serene walking trails. Ready to find your new home? Browse availability or schedule a tour today! Prefer to explore on your own time? Self-guided tours are available.</p>",
    "property_type": "Apartments",
    "property_website_url": "https://www.caseusa.com/apartments/ks/wichita/silver-springs/",
    "property_company_name": "Case & Associates",
    "_slug": "silver-springs-apts",
    "_stateSlug": "ks",
    "_citySlug": "wichita"
  },
  {
    "multihub_property_id": "6767906449166550",
    "multihub_company_id": "5767906449162419",
    "property_name": "Villas of Waterford",
    "property_slug": "villas-of-waterford",
    "property_address": "8510 E. 29th St. N.",
    "property_address_1": "8510 E. 29th St. N.",
    "property_address_city": "Wichita",
    "property_address_state": "KS",
    "property_address_zip": "67226",
    "property_address_latitude": "37.7386",
    "property_address_longitude": "-97.2383",
    "property_phone": "(316) 227-1796",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019db8df-7c66-724c-bb1b-7a3c92620a3e.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019cfb4f-c0e8-72fc-a0ea-cc501584e7d4.webp",
    "property_primary_color": "#62645d",
    "property_price_range": "1064 - 1484",
    "property_price_min": "1064",
    "property_price_max": "1484",
    "property_bedrooms_range": "1 - 2",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "2",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "789 - 1110",
    "property_short_description": "At Villas of Waterford in Wichita, KS, every detail is designed for your lifestyle. Enjoy two sparkling outdoor pools, a state-of-the-art fitness center, and a cozy Grill & Chill area. With spacious one and two-bedroom floor plans, you’ll find the perfect blend of comfort and luxury. Begin your new chapter today! Prefer to explore on your own time? Self-guided tours are available.",
    "property_type": "Apartments",
    "property_website_url": "https://www.caseusa.com/apartments/ks/wichita/villas-of-waterford/",
    "property_company_name": "Case & Associates",
    "_slug": "villas-of-waterford",
    "_stateSlug": "ks",
    "_citySlug": "wichita"
  },
  {
    "multihub_property_id": "6767906449166551",
    "multihub_company_id": "5767906449162419",
    "property_name": "Watercress Apartments",
    "property_slug": "watercress-apartments",
    "property_address": "4060 Reed Ave.",
    "property_address_1": "4060 Reed Ave.",
    "property_address_city": "Maize",
    "property_address_state": "KS",
    "property_address_zip": "67101",
    "property_address_latitude": "37.7576",
    "property_address_longitude": "-97.46",
    "property_phone": "(316) 618-7429",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019fb44f-b0f5-72e2-ab31-4a43f4632f89.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019cfb50-11e8-734e-b4ea-c8fc4e205e2d.webp",
    "property_primary_color": "#000000",
    "property_price_range": "1119 - 1619",
    "property_price_min": "1119",
    "property_price_max": "1619",
    "property_bedrooms_range": "1 - 2",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "2",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "789 - 1267",
    "property_short_description": "<p>At Watercress in Maize, KS, modern living meets community charm. Choose from spacious one to three-bedroom apartments featuring island kitchens, hardwood floors, and balconies. Enjoy amenities like a pool, fitness center, and dog park—all within a tranquil, controlled-access environment. Join us and embrace a lifestyle you'll love! Prefer to explore on your own time? Self-guided tours are available.</p>",
    "property_type": "Apartments",
    "property_total_units": "268",
    "property_website_url": "https://www.caseusa.com/apartments/ks/maize/watercress/",
    "property_company_name": "Case & Associates",
    "_slug": "watercress-apartments",
    "_stateSlug": "ks",
    "_citySlug": "maize"
  },
  {
    "multihub_property_id": "6767906449166552",
    "multihub_company_id": "5767906449162419",
    "property_name": "West 530",
    "property_slug": "west-530",
    "property_address": "3660 W 530 Rd",
    "property_address_1": "3660 W 540 Rd",
    "property_address_city": "Pryor",
    "property_address_state": "OK",
    "property_address_zip": "74361",
    "property_address_latitude": "36.249352",
    "property_address_longitude": "-95.3719351",
    "property_phone": "(844) 755-4278",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019cfb4f-c8e4-7497-8ba7-6906cf5b9588.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019cfb50-92c5-707e-8a39-e2ae8e966e86.webp",
    "property_primary_color": "#000000",
    "property_price_range": "1199 - 1419",
    "property_price_min": "1199",
    "property_price_max": "1419",
    "property_bedrooms_range": "1 - 2",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "2",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "789 - 1050",
    "property_short_description": "<p>At West 530 in Pryor, OK, find your perfect blend of style and comfort with one- and two-bedroom floor plans. Enjoy luxury amenities like a serene pond, vibrant dog park, and state-of-the-art fitness center. Experience a lifestyle that elevates everyday living—schedule a tour or check availability to start your journey today! Prefer to explore on your own time? Self-guided tours are available.</p>",
    "property_type": "Apartments",
    "property_total_units": "128",
    "property_website_url": "https://www.caseusa.com/apartments/ok/pryor/west-530/",
    "property_company_name": "Case & Associates",
    "_slug": "west-530",
    "_stateSlug": "ok",
    "_citySlug": "pryor"
  },
  {
    "multihub_property_id": "6767906449167035",
    "multihub_company_id": "5767906449162419",
    "property_name": "Bend at New Road",
    "property_slug": "bend-at-new-road",
    "property_address": "3000 S. New Road",
    "property_address_1": "3000 S. New Road",
    "property_address_city": "Waco",
    "property_address_state": "TX",
    "property_address_zip": "76706",
    "property_address_latitude": "31.5084",
    "property_address_longitude": "-97.1374",
    "property_phone": "(254) 632-5037",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019cfb4f-de71-775c-baa4-ce2088b93758.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019cfb50-3ad2-71f2-9a27-63728aead156.webp",
    "property_primary_color": "#818688",
    "property_price_range": "1559 - 1859",
    "property_price_min": "1559",
    "property_price_max": "1859",
    "property_bedrooms_range": "2 - 2",
    "property_bedrooms_min": "2",
    "property_bedrooms_max": "2",
    "property_bathrooms_range": "2 - 2",
    "property_bathrooms_min": "2",
    "property_bathrooms_max": "2",
    "property_sqft_range": "1050 - 1267",
    "property_short_description": "Welcome to Bend at New Road, where luxury meets comfort in Waco, TX! Choose from spacious one or two-bedroom floor plans featuring modern designs and upscale amenities. Enjoy relaxing days by the resort-worthy pool, energizing workouts in our 24-hour fitness center, and playful moments at our onsite dog park. Your perfect home awaits! Prefer to explore on your own time? Self-guided tours are available.",
    "property_type": "Apartments",
    "property_total_units": "252",
    "property_website_url": "https://www.caseusa.com/apartments/tx/waco/bend-at-new-road/",
    "property_company_name": "Case & Associates",
    "_slug": "bend-at-new-road",
    "_stateSlug": "tx",
    "_citySlug": "waco"
  },
  {
    "multihub_property_id": "6767906449167036",
    "multihub_company_id": "5767906449162419",
    "property_name": "Coffee Creek",
    "property_slug": "coffee-creek",
    "property_address": "14100 E. 106th St. North",
    "property_address_1": "14100 E. 106th St. North",
    "property_address_city": "Owasso",
    "property_address_state": "OK",
    "property_address_zip": "74055",
    "property_address_latitude": "36.3072",
    "property_address_longitude": "-95.8142",
    "property_phone": "(539) 200-6510",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019cfb50-836d-745e-943a-4c666041e42b.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019cfb50-6f09-76ff-b975-cbfb7eee4bfb.webp",
    "property_primary_color": "#827466",
    "property_price_range": "1154 - 1644",
    "property_price_min": "1154",
    "property_price_max": "1644",
    "property_bedrooms_range": "1 - 2",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "2",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "789 - 1176",
    "property_short_description": "Welcome to Coffee Creek in Owasso, OK, where comfort meets convenience. Our thoughtfully designed one- and two-bedroom apartments boast modern amenities like a swimming pool, 24-hour fitness center, and a welcoming onsite dog park. Enjoy gatherings in our picnic area or relax in your spacious apartment with vaulted ceilings. Prefer to explore on your own time? Self-guided tours are available.",
    "property_type": "Apartments",
    "property_website_url": "https://www.caseusa.com/apartments/ok/owasso/coffee-creek/",
    "property_company_name": "Case & Associates",
    "_slug": "coffee-creek",
    "_stateSlug": "ok",
    "_citySlug": "owasso"
  },
  {
    "multihub_property_id": "6767906449167037",
    "multihub_company_id": "5767906449162419",
    "property_name": "The Colonies at Hillside",
    "property_slug": "the-colonies-at-hillside",
    "property_address": "7550 S. Hillside Road",
    "property_address_1": "7550 S. Hillside Road",
    "property_address_city": "Amarillo",
    "property_address_state": "TX",
    "property_address_zip": "79119",
    "property_address_latitude": "35.1484",
    "property_address_longitude": "-101.9233",
    "property_phone": "(806) 304-6308",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019cfb50-7643-74ed-a9f7-5320d688a856.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019d9bd5-6e35-734f-a660-3e0744b6819f.webp",
    "property_primary_color": "#474d43",
    "property_price_range": "1360 - 1769",
    "property_price_min": "1360",
    "property_price_max": "1769",
    "property_bedrooms_range": "1 - 2",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "2",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "800 - 1145",
    "property_short_description": "Welcome to The Colonies at Hillside, where modern comfort meets style in Amarillo, TX. Choose from spacious one or two-bedroom layouts, complete with lofty ceilings and private balconies. Enjoy resort-style amenities like a shimmering pool, scenic BBQ areas, and a vibrant bark park—perfect for both relaxation and recreation. Prefer to explore on your own time? Self-guided tours are available.",
    "property_type": "Apartments",
    "property_website_url": "https://www.caseusa.com/apartments/tx/amarillo/colonies-at-hillside/",
    "property_company_name": "Case & Associates",
    "_slug": "the-colonies-at-hillside",
    "_stateSlug": "tx",
    "_citySlug": "amarillo"
  },
  {
    "multihub_property_id": "6767906449167038",
    "multihub_company_id": "5767906449162419",
    "property_name": "Cottages at Abbey Glen",
    "property_slug": "cottages-at-abbey-glen",
    "property_address": "5240 114th Street",
    "property_address_1": "5240 114th Street",
    "property_address_city": "Lubbock",
    "property_address_state": "TX",
    "property_address_zip": "79424",
    "property_address_latitude": "33.4914",
    "property_address_longitude": "-101.9258",
    "property_phone": "(806) 216-3086",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167038/019cfb51-0a7b-7458-b44f-3c25b36dcd8a.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167038/019cfb51-0a77-700d-b3f8-4922f663c8a6.webp",
    "property_primary_color": "#324d58",
    "property_price_range": "1074 - 1524",
    "property_price_min": "1074",
    "property_price_max": "1524",
    "property_bedrooms_range": "1 - 2",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "2",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": " - 1176",
    "property_short_description": "At Cottages at Abbey Glen in Lubbock, TX, experience modern comfort in spacious one and two-bedroom apartments. Unwind by the resort-style pool or socialize in our grill and chill area. With pet-friendly amenities, 24-hour fitness access, and beautiful loft-style living options, your perfect home awaits—schedule a tour today!",
    "property_type": "Apartments",
    "property_website_url": "https://www.caseusa.com/apartments/tx/lubbock/cottages-at-abbey-glen/",
    "property_company_name": "Case & Associates",
    "_slug": "cottages-at-abbey-glen",
    "_stateSlug": "tx",
    "_citySlug": "lubbock"
  },
  {
    "multihub_property_id": "6767906449167039",
    "multihub_company_id": "5767906449162419",
    "property_name": "Cottages at Tallgrass Point",
    "property_slug": "cottages-at-tallgrass-point",
    "property_address": "8748 North Mingo Road",
    "property_address_1": "8748 N Mingo Rd",
    "property_address_city": "Owasso",
    "property_address_state": "OK",
    "property_address_zip": "74055",
    "property_address_latitude": "36.2798297",
    "property_address_longitude": "-95.86697579999999",
    "property_phone": "(539) 224-5633",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019fb452-9ce8-72cc-ae26-43254ed61101.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019cfb51-10ac-736f-ac0d-e4381ff1f26a.webp",
    "property_primary_color": "#324d58",
    "property_price_range": "1174 - 1419",
    "property_price_min": "1174",
    "property_price_max": "1419",
    "property_bedrooms_range": "1 - 2",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "2",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "789 - 1108",
    "property_short_description": "Welcome to Cottages at Tallgrass Point, where modern living meets comfort in Owasso, OK. Our beautifully designed one- and two-bedroom apartments feature gourmet kitchens, cozy fireplaces, and private patios. Enjoy resort-style amenities like a zero-entry pool, outdoor lounges, and a pet-friendly environment. Your perfect home awaits! Prefer to explore on your own time? Self-guided tours are available.",
    "property_type": "Apartments",
    "property_total_units": "266",
    "property_website_url": "https://www.caseusa.com/apartments/ok/owasso/cottages-at-tallgrass-point/",
    "property_company_name": "Case & Associates",
    "_slug": "cottages-at-tallgrass-point",
    "_stateSlug": "ok",
    "_citySlug": "owasso"
  },
  {
    "multihub_property_id": "6767906449167040",
    "multihub_company_id": "5767906449162419",
    "property_name": "The Crest",
    "property_slug": "the-crest",
    "property_address": "345 Shadow Mountain Dr.",
    "property_address_1": "345 Shadow Mountain Dr.",
    "property_address_city": "El Paso",
    "property_address_state": "TX",
    "property_address_zip": "79912",
    "property_address_latitude": "31.8356",
    "property_address_longitude": "-106.5271",
    "property_phone": "(915) 284-8917",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019cfb53-296d-75cf-85fa-8510acb94549.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019cfb51-9592-76a4-8f50-ebe6498939dd.webp",
    "property_primary_color": "#3d3d3f",
    "property_price_range": "1199 - 1703",
    "property_price_min": "1199",
    "property_price_max": "1703",
    "property_bedrooms_range": "1 - 3",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "3",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "639 - 1036",
    "property_short_description": "Welcome to The Crest in El Paso, where modern living meets comfort. Choose from thoughtfully designed one, two, or three-bedroom floor plans, complete with upgraded stainless-steel appliances and spacious closets. Enjoy amenities like a refreshing pool, BBQ area, and pet park. Your perfect home awaits—explore our availability today! Prefer to explore on your own time? Self-guided tours are available.",
    "property_type": "Apartments",
    "property_total_units": "232",
    "property_website_url": "https://www.caseusa.com/apartments/tx/el-paso/the-crest/",
    "property_company_name": "Case & Associates",
    "_slug": "the-crest",
    "_stateSlug": "tx",
    "_citySlug": "el-paso"
  },
  {
    "multihub_property_id": "6767906449167041",
    "multihub_company_id": "5767906449162419",
    "property_name": "Icon at Broken Arrow Apartments",
    "property_slug": "icon-at-broken-arrow-apartments",
    "property_address": "4801 S. Elm Pl.",
    "property_address_1": "4801 S. Elm Pl.",
    "property_address_city": "Broken Arrow",
    "property_address_state": "OK",
    "property_address_zip": "74011",
    "property_address_latitude": "36.0027",
    "property_address_longitude": "-95.7972",
    "property_phone": "(539) 224-2962",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019fb453-230f-7241-a5ae-4baff0538188.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019cfb51-c309-76ca-b5b8-ebc455dda09a.webp",
    "property_primary_color": "#3d3d3f",
    "property_price_range": "1109 - 1509",
    "property_price_min": "1109",
    "property_price_max": "1509",
    "property_bedrooms_range": "1 - 2",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "2",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "789 - 1108",
    "property_short_description": "<p>Welcome to Icon at Broken Arrow Apartments, where comfort meets convenience in the heart of Broken Arrow, OK. Choose from stylish one and two-bedroom floor plans, enjoy our pet-friendly community, and relax by the swimming pool. Secure your new home today and schedule a tour to experience it all! Prefer to explore on your own time? Self-guided tours are available.</p>",
    "property_type": "Apartments",
    "property_website_url": "https://www.caseusa.com/apartments/ok/broken-arrow/icon-at-broken-arrow/",
    "property_company_name": "Case & Associates",
    "_slug": "icon-at-broken-arrow-apartments",
    "_stateSlug": "ok",
    "_citySlug": "broken-arrow"
  },
  {
    "multihub_property_id": "6767906449167042",
    "multihub_company_id": "5767906449162419",
    "property_name": "Icon at Hewitt",
    "property_slug": "icon-at-hewitt",
    "property_address": "201 Ritchie Road",
    "property_address_1": "201 Ritchie Road",
    "property_address_city": "Hewitt",
    "property_address_state": "TX",
    "property_address_zip": "76643",
    "property_address_latitude": "31.4452",
    "property_address_longitude": "-97.2073",
    "property_phone": "(254) 632-5671",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb51-746b-75f9-9307-95a8b029cb4a.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167042/019cfb51-d69f-76f2-accd-b90fc0c8f320.webp",
    "property_primary_color": "#3d3d3f",
    "property_price_range": "1539 - 1849",
    "property_price_min": "1539",
    "property_price_max": "1849",
    "property_bedrooms_range": "2 - 2",
    "property_bedrooms_min": "2",
    "property_bedrooms_max": "2",
    "property_bathrooms_range": "2 - 2",
    "property_bathrooms_min": "2",
    "property_bathrooms_max": "2",
    "property_sqft_range": "1050 - 1267",
    "property_short_description": "At Icon at Hewitt in Hewitt, TX, find spacious one-bedroom and two-bedroom layouts that blend modern comfort with pet-friendly amenities. Enjoy resort-style living with a stunning pool, relaxing sundecks, and a 24-hour fitness center. Your perfect home awaits—check our availability and schedule a tour today! Prefer to explore on your own time? Self-guided tours are available.",
    "property_type": "Apartments",
    "property_total_units": "264",
    "property_website_url": "https://www.caseusa.com/apartments/tx/hewitt/icon-at-hewitt/",
    "property_company_name": "Case & Associates",
    "_slug": "icon-at-hewitt",
    "_stateSlug": "tx",
    "_citySlug": "hewitt"
  },
  {
    "multihub_property_id": "6767906449167043",
    "multihub_company_id": "5767906449162419",
    "property_name": "Park at Mission Hills",
    "property_slug": "park-at-mission-hills",
    "property_address": "2700 N. 7th Street",
    "property_address_1": "2700 N. 7th Street",
    "property_address_city": "Broken Arrow",
    "property_address_state": "OK",
    "property_address_zip": "74012",
    "property_address_latitude": "36.0777",
    "property_address_longitude": "-95.7843",
    "property_phone": "(539) 269-1171",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019dbbe9-f8f2-725a-a972-d473b508b5ea.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019cfb52-52ad-73e3-9ee0-a17fc64d4722.webp",
    "property_primary_color": "#3d3d3f",
    "property_price_range": "1139 - 1479",
    "property_price_min": "1139",
    "property_price_max": "1479",
    "property_bedrooms_range": "1 - 2",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "2",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "789 - 1108",
    "property_short_description": "<p>Welcome to Park at Mission Hills, your serene retreat in Broken Arrow, OK. Choose from spacious one or two-bedroom floor plans with modern amenities like 24-hour fitness centers, resort-style pools, and relaxing ponds. Pet-friendly and equipped for comfort, it’s where home meets lifestyle. Schedule your tour and find your new haven today! Prefer to explore on your own time? Self-guided tours are available.</p>",
    "property_type": "Apartments",
    "property_website_url": "https://www.caseusa.com/apartments/ok/broken-arrow/park-at-mission-hills/",
    "property_company_name": "Case & Associates",
    "_slug": "park-at-mission-hills",
    "_stateSlug": "ok",
    "_citySlug": "broken-arrow"
  },
  {
    "multihub_property_id": "6767906449167044",
    "multihub_company_id": "5767906449162419",
    "property_name": "Persimmon Square Apartments",
    "property_slug": "persimmon-square-apartments",
    "property_address": "12113 Heritage Park Road",
    "property_address_1": "12113 Heritage Park Road",
    "property_address_city": "Oklahoma City",
    "property_address_state": "OK",
    "property_address_zip": "73120",
    "property_address_latitude": "35.5933",
    "property_address_longitude": "-97.5469",
    "property_phone": "(405) 445-6219",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167044/019cfb53-5e25-74ba-9a2e-b9226cf348a9.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167044/019cfb53-5117-77dc-b11e-85f24838965d.webp",
    "property_primary_color": "#556771",
    "property_price_range": "929 - 1379",
    "property_price_min": "929",
    "property_price_max": "1379",
    "property_bedrooms_range": "1 - 2",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "2",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "550 - 1300",
    "property_short_description": "At Persimmon Square Apartments in Oklahoma City, your perfect home awaits. Choose from spacious one and two-bedroom floor plans featuring resort-style amenities, including a refreshing pool, resident lounge, and business center with free WiFi. Embrace comfort with walk-in closets and the convenience of online rental payments. Your new lifestyle starts here!",
    "property_type": "Apartments",
    "property_total_units": "109",
    "property_website_url": "https://www.caseusa.com/apartments/ok/oklahoma-city/persimmon-square/",
    "property_company_name": "Case & Associates",
    "_slug": "persimmon-square-apartments",
    "_stateSlug": "ok",
    "_citySlug": "oklahoma-city"
  },
  {
    "multihub_property_id": "6767906449167045",
    "multihub_company_id": "5767906449162419",
    "property_name": "Phoenix Apts",
    "property_slug": "phoenix-apts.",
    "property_address": "7401 Phoenix Avenue",
    "property_address_1": "7401 Phoenix Avenue",
    "property_address_city": "El Paso",
    "property_address_state": "TX",
    "property_address_zip": "79915",
    "property_address_latitude": "31.7553",
    "property_address_longitude": "-106.3691",
    "property_phone": "(915) 465-4537",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019cfb53-0a3b-7790-ab9b-977663961c58.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019cfb53-6a0f-720a-9b3f-241b995ff71c.webp",
    "property_primary_color": "#9b6e64",
    "property_price_range": "940 - 1125",
    "property_price_min": "940",
    "property_price_max": "1125",
    "property_bedrooms_range": "1 - 2",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "2",
    "property_bathrooms_range": "1 - 1",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "1",
    "property_sqft_range": "588 - 767",
    "property_short_description": "At Phoenix Apts, your new El Paso home awaits! Choose from spacious one, two, or three-bedroom layouts adorned with modern amenities like a fitness center, pool, and pet-friendly spaces. Enjoy the convenience of on-site management, laundry facilities, and a vibrant clubhouse. Experience comfort and community—schedule your visit today! Prefer to explore on your own time? Self-guided tours are available.",
    "property_type": "Apartments",
    "property_total_units": "336",
    "property_website_url": "https://www.caseusa.com/apartments/tx/el-paso/the-phoenix/",
    "property_company_name": "Case & Associates",
    "_slug": "phoenix-apts",
    "_stateSlug": "tx",
    "_citySlug": "el-paso"
  },
  {
    "multihub_property_id": "6767906449167046",
    "multihub_company_id": "5767906449162419",
    "property_name": "The Pointe Of Ridgeland",
    "property_slug": "the-pointe-of-ridgeland",
    "property_address": "831 Rice Road",
    "property_address_1": "831 Rice Road",
    "property_address_city": "Ridgeland",
    "property_address_state": "MS",
    "property_address_zip": "39157",
    "property_address_latitude": "32.419",
    "property_address_longitude": "-90.0989",
    "property_phone": "(601) 514-6634",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019cfb54-8031-73a9-a48e-965c6e21fb40.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019cfb53-d267-702f-b733-a81e38b3da78.webp",
    "property_primary_color": "#556771",
    "property_price_range": "1209 - 1769",
    "property_price_min": "1209",
    "property_price_max": "1769",
    "property_bedrooms_range": "1 - 2",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "2",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "650 - 1225",
    "property_short_description": "At The Pointe of Ridgeland, your ideal home awaits in a vibrant community nestled in Ridgeland, MS. Choose from spacious one, two, or three-bedroom floor plans, complemented by amenities like a sparkling outdoor pool, a cozy BBQ area, and a fun bark park. Discover a lifestyle filled with comfort and convenience today! Prefer to explore on your own time? Self-guided tours are available.",
    "property_type": "Apartments",
    "property_website_url": "https://www.caseusa.com/apartments/ms/ridgeland/the-pointe-of-ridgeland/",
    "property_company_name": "Case & Associates",
    "_slug": "the-pointe-of-ridgeland",
    "_stateSlug": "ms",
    "_citySlug": "ridgeland"
  },
  {
    "multihub_property_id": "6767906449167051",
    "multihub_company_id": "5767906449162419",
    "property_name": "Scissortail Crossing",
    "property_slug": "scissortail-crossing",
    "property_address": "2800 North 23rd Street",
    "property_address_1": "2800 North 23rd Street",
    "property_address_city": "Broken Arrow",
    "property_address_state": "OK",
    "property_address_zip": "74014",
    "property_address_latitude": "36.0798",
    "property_address_longitude": "-95.761",
    "property_phone": "(918) 246-6518",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019cfb54-d888-74e1-9149-398aed96e9b3.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019cfb54-0543-720a-803e-ccaa2333a3b3.webp",
    "property_primary_color": "#324d58",
    "property_price_range": "1164 - 1704",
    "property_price_min": "1164",
    "property_price_max": "1704",
    "property_bedrooms_range": "1 - 2",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "2",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "789 - 1267",
    "property_short_description": "<p>Welcome to Scissortail Crossing in Broken Arrow, OK, where contemporary elegance meets comfort. Choose from our thoughtfully designed one- and two-bedroom floor plans, and enjoy resort-style amenities like a poolside grill area, fitness center, and tranquil courtyards with pet stations. Your perfect home awaits—schedule your tour today! Prefer to explore on your own time? Self-guided tours are available.</p>",
    "property_type": "Apartments",
    "property_website_url": "https://www.caseusa.com/apartments/ok/broken-arrow/scissortail-crossing/",
    "property_company_name": "Case & Associates",
    "_slug": "scissortail-crossing",
    "_stateSlug": "ok",
    "_citySlug": "broken-arrow"
  },
  {
    "multihub_property_id": "6767906449167288",
    "multihub_company_id": "5767906449162419",
    "property_name": "Tuscany Place",
    "property_slug": "tuscany-place",
    "property_address": "6312 73rd Street",
    "property_address_1": "6312 73rd Street",
    "property_address_city": "Lubbock",
    "property_address_state": "TX",
    "property_address_zip": "79424",
    "property_address_latitude": "33.5287",
    "property_address_longitude": "-101.9543",
    "property_phone": "(806) 304-6346",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167288/019cfb54-08a4-731a-a122-e1d30d4fce4c.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167288/019cfb54-08a3-759f-8a2c-581885c177e5.webp",
    "property_primary_color": "#473729",
    "property_price_range": "1034 - 1264",
    "property_price_min": "1034",
    "property_price_max": "1264",
    "property_bedrooms_range": "1 - 2",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "2",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": " - 856",
    "property_short_description": "At Tuscany Place in Lubbock, TX, luxury meets comfort with thoughtfully designed one- and two-bedroom floor plans. Enjoy cozy evenings by the outdoor fire pit, stay fit in our 24-hour gym, or unwind by the resort-style pool. Your pet-friendly haven awaits—connect with exceptional living today!",
    "property_type": "Apartments",
    "property_total_units": "276",
    "property_website_url": "https://www.caseusa.com/apartments/tx/lubbock/tuscany-place/",
    "property_company_name": "Case & Associates",
    "_slug": "tuscany-place",
    "_stateSlug": "tx",
    "_citySlug": "lubbock"
  },
  {
    "multihub_property_id": "6767906449167289",
    "multihub_company_id": "5767906449162419",
    "property_name": "Remington Amarillo Apts",
    "property_slug": "remington-amarillo-apts",
    "property_address": "8801 W. Tarter",
    "property_address_1": "8801 W. Tarter",
    "property_address_city": "Amarillo",
    "property_address_state": "TX",
    "property_address_zip": "79119",
    "property_address_latitude": "35.167",
    "property_address_longitude": "-101.9398",
    "property_phone": "(806) 425-1448",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167289/019cfb55-4fb9-7225-bfd4-56a80ad4c93d.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167289/019cfb55-3d94-771d-85ce-97faae2d6fc6.webp",
    "property_primary_color": "#3d3d3f",
    "property_price_range": "1294 - 1799",
    "property_price_min": "1294",
    "property_price_max": "1799",
    "property_bedrooms_range": "1 - 3",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "3",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "725 - 1110",
    "property_short_description": "<p>Welcome to Remington Amarillo, where modern living meets comfort! Choose from our thoughtfully designed one, two, or three-bedroom apartments, featuring gourmet kitchens, spacious walk-in closets, and private balconies. Enjoy plush carpeting and vaulted ceilings in select units. Make your move to Amarillo and find your new home today! Prefer to explore on your own time? Self-guided tours are available.</p>",
    "property_type": "Apartments",
    "property_website_url": "https://www.caseusa.com/apartments/tx/amarillo/remington/",
    "property_company_name": "Case & Associates",
    "_slug": "remington-amarillo-apts",
    "_stateSlug": "tx",
    "_citySlug": "amarillo"
  },
  {
    "multihub_property_id": "6767906449167297",
    "multihub_company_id": "5767906449162419",
    "property_name": "Summit Ridge Villas",
    "property_slug": "summit-ridge-villas",
    "property_address": "1721 NW 115th Terrace",
    "property_address_1": "1721 NW 115th Terrace",
    "property_address_city": "Oklahoma City",
    "property_address_state": "OK",
    "property_address_zip": "73120",
    "property_address_latitude": "35.5869",
    "property_address_longitude": "-97.5444",
    "property_phone": "4057846734",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019cfb55-b841-7774-acca-099d805875f4.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167297/019cfb55-ec18-75dc-bf4d-a19cea16f913.webp",
    "property_primary_color": "#000000",
    "property_price_range": "1475 - 1475",
    "property_price_min": "1475",
    "property_price_max": "1475",
    "property_bedrooms_range": "2",
    "property_bedrooms_min": "2",
    "property_bedrooms_max": "2",
    "property_bathrooms_range": "2 - 2",
    "property_bathrooms_min": "2",
    "property_bathrooms_max": "2",
    "property_sqft_range": "933 - 933",
    "property_short_description": "Welcome to Summit Ridge Villas in Oklahoma City, where modern living meets comfort. Choose from our spacious two-bedroom floor plans and indulge in thoughtful amenities like pet-friendly spaces, outdoor retreats, and energy-efficient appliances. Experience the ideal blend of style and convenience—your new home awaits just a click away! Prefer to explore on your own time? Self-guided tours are available.",
    "property_type": "Apartments",
    "property_total_units": "94",
    "property_website_url": "https://www.caseusa.com/apartments/ok/oklahoma-city/summit-ridge-villas/",
    "property_company_name": "Case & Associates",
    "_slug": "summit-ridge-villas",
    "_stateSlug": "ok",
    "_citySlug": "oklahoma-city"
  },
  {
    "multihub_property_id": "6767906449167311",
    "multihub_company_id": "5767906449162419",
    "property_name": "Zeal at Quail",
    "property_slug": "zeal-at-quail",
    "property_address": "14712 Mezzaluna Blvd",
    "property_address_1": "14712 Mezzaluna Blvd",
    "property_address_city": "Oklahoma City",
    "property_address_state": "OK",
    "property_address_zip": "73134",
    "property_address_latitude": "35.6193429",
    "property_address_longitude": "-97.5598094",
    "property_phone": "(405) 993-4130",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d07de-3be4-769c-8a5e-910b99229af0.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d07dc-aae3-745f-890a-9965240140e3.webp",
    "property_primary_color": "#dfd2c1",
    "property_price_range": "1689 - 2100",
    "property_price_min": "1689",
    "property_price_max": "2100",
    "property_bedrooms_range": "2 - 2",
    "property_bedrooms_min": "2",
    "property_bedrooms_max": "2",
    "property_bathrooms_range": "2 - 2",
    "property_bathrooms_min": "2",
    "property_bathrooms_max": "2",
    "property_sqft_range": "933 - 1080",
    "property_short_description": "<p>At Zeal at Quail in Oklahoma City, our thoughtfully designed one and two-bedroom apartments blend comfort with modern luxury. Enjoy exceptional amenities like a sparkling pool, fitness areas, and pet-friendly fenced yards, all under the watchful eye of our dedicated management team. Make your move—explore our vibrant community today! Prefer to explore on your own time? Self-guided tours are available.</p>",
    "property_type": "Apartments",
    "property_total_units": "152",
    "property_website_url": "zealatquailapartmentsokc.com",
    "property_company_name": "Case & Associates",
    "_slug": "zeal-at-quail",
    "_stateSlug": "ok",
    "_citySlug": "oklahoma-city"
  },
  {
    "multihub_property_id": "6767906449167705",
    "multihub_company_id": "5767906449162419",
    "property_name": "Bluffs at Catoosa",
    "property_slug": "bluffs-at-catoosa",
    "property_address": "1201 N Highway 167",
    "property_address_1": "1201 N Highway 167",
    "property_address_city": "Catoosa",
    "property_address_state": "OK",
    "property_address_zip": "74015",
    "property_address_latitude": "36.1716946",
    "property_address_longitude": "-95.75990039999999",
    "property_phone": "(888) 991-7336",
    "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167705/01a0aa68-cac0-767f-a2a4-d3293019f855.webp",
    "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167705/01a0aa68-a10c-75d7-8df8-1fb57cbd5e83.webp",
    "property_primary_color": "#daba6b",
    "property_price_range": "1199 - 2019",
    "property_price_min": "1199",
    "property_price_max": "2019",
    "property_bedrooms_range": "1 - 3",
    "property_bedrooms_min": "1",
    "property_bedrooms_max": "3",
    "property_bathrooms_range": "1 - 2",
    "property_bathrooms_min": "1",
    "property_bathrooms_max": "2",
    "property_sqft_range": "789 - 1473",
    "property_short_description": "<p>At Artisan Crossing Apts in Norman, Oklahoma, your dream home awaits! Choose from stylish one and two-bedroom floor plans featuring modern amenities like a resort-style pool, 24-hour fitness center, and dog park. Experience the allure of expansive living spaces and unmatched convenience—your new lifestyle starts here! Prefer to explore on your own time? Self-guided tours are available.</p>",
    "property_website_url": "bluffsatcatoosaapartments.com",
    "property_company_name": "Case & Associates",
    "_slug": "bluffs-at-catoosa",
    "_stateSlug": "ok",
    "_citySlug": "catoosa"
  }
];

export const generatedAt = '2026-11-04T16:50:51.011Z';
